<template>
  <div v-if="visible" id="tabVesselEq" class="tab-vessel-eq">
    <div style="display:flex;flex-direction:row;">
      <div v-show="(showBookingEdi1 && showButton) || !readonly" class="section">
        <div class="operations">
          <div v-show="cooperateEdit" class="triggers">
            <div>
              <el-menu
                v-show="showBookingEdi1 && showButton"
                text-color="#404144"
                active-text-color="#404144"
                mode="horizontal"
                class="el-menu-button el-button el-button--primary el-button--mini"
                style="width: 90px;vertical-align: top"
                @select="toBookingPre"
              >
                <el-submenu :disabled="bookingEdi1Disabled || !(action === 'look' && form.uuid)" index="index">
                  <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.EDIBooking') }}</span>
                  <el-submenu index="original">
                    <template slot="title">{{ $t('SeaExport.Original') }}</template>
                    <el-menu-item index="API0" :disabled="!bookingEDIApiOpen && !isHZ">API</el-menu-item>
                    <el-menu-item index="FTP1" :disabled="isHZ">FTP</el-menu-item>
                    <el-menu-item index="RPA1" :disabled="isHZ">RPA</el-menu-item>
                  </el-submenu>
                  <el-submenu index="correct">
                    <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                    <el-menu-item index="FTP0" :disabled="isHZ">FTP</el-menu-item>
                    <el-menu-item index="API1" :disabled="!bookingEDIApiOpen || isHZ">API</el-menu-item>
                  </el-submenu>
                  <el-submenu index="shutOut">
                    <template slot="title">{{ $t('SeaExport.ShutOut') }}</template>
                    <el-menu-item index="FTP2" :disabled="isHZ">FTP</el-menu-item>
                    <el-menu-item index="API2" :disabled="!isHZ">API</el-menu-item>
                  </el-submenu>
                  <el-menu-item v-if="seAllowReceiptImport" :index="$t('SeaExport.ReceiptImport')">{{ $t('SeaExport.ReceiptImport') }}</el-menu-item>
                </el-submenu>
              </el-menu>
              <el-button no="1" type="primary" class="can-operate" @click="loadBookingLog">{{ $t('CargoMsg.Cargo_BookingLog') }}</el-button>
              <el-button v-show="!readonly && [1, 2, 3].includes(isInputMbl)" v-permission="['button_SEBooking_generateMBL']" no="2" type="primary" @click="generateMblNo">{{ $t('SeaExport.GeneratePrimaryDocNo') }}</el-button>
              <el-button v-show="!readonly && form.mbl && [1, 2, 3].includes(isInputMbl)" v-permission="['button_SEBooking_generateSoNo']" no="3" type="primary" @click="generateSoNo">{{ $t('SeaExport.AddSpellCustomsOrderNo') }}</el-button>
              <el-button v-show="readonly && form.mbl && form.masterFlag && [1, 2, 3].includes(isInputMbl)" v-permission="['button_SEBooking_generateMBL']" no="4" type="primary" @click="allocateSoNo">{{ $t('SeaExport.DistributionCustomsNo') }}</el-button>
              <el-checkbox v-show="enableShipperConsignNotify" v-model="form.shipperLock" no="shipperLock" style="margin-left: 5px;" :disabled="enableShipperLock">{{ $t('SeaExport.ShipperLocked') }}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="padding-left: 0">
        <el-button
          v-show="form.uuid && showResubscribeBookingReceipt && canSubscribeReceipt && [SystemConstants.JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code, SystemConstants.JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL.code].indexOf(form.bookingState) > -1"
          no="resubscribeBookingReceipt"
          type="primary"
          @click="subscribeReceiptExec"
        >
          {{ $t('CargoMsg.Cargo_ResubscribeBookingReceipt') }}
        </el-button>
      </div>
    </div>
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column">
          <el-form label-width="85px" label-position="right">
            <div>
              <span class="title">{{ $t('SeaExport.BookingInfo') }}</span>
              <el-form-item v-show="showVessel" :label="$t('SeaExport.VesselAndVoyage')">
                <el-input v-model="form.vesselAndVoyage" no="vesselAndVoyage" :disabled="readonlyVessel" @input="(value) => pm.onVesselAndVoyageChange(value)" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Vessel')" :class="fieldClass.vesselTitle">
                <cargo-advance-select
                  no="5"
                  :disabled="!pm.lclslaveEnabledExcludeExportToImport"
                  :select-type="selectTypeNames.static_data_Vessel"
                  :cache="false"
                  filterable
                  :allow-create="pm._allowEditingVessel"
                  :default-value="form.vessel"
                  :static-options="pm.vesselList"
                  :class="importDifferenceField.vessel ? fieldClass.vessel + ' red-border' : fieldClass.vessel"
                  @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Voyage')" :class="fieldClass.voyageFlightTitle">
                <div style="display: flex">
                  <cargo-advance-select
                    ref="voyageFlight"
                    no="6"
                    :static-options="pm._voyages || []"
                    :cache="false"
                    :default-value="form.voyageFlight"
                    :disabled="!pm.lclslaveEnabledExcludeExportToImport"
                    filterable
                    clearable
                    :allow-create="pm.editVoyageMode===1"
                    :class="importDifferenceField.voyageFlight ? fieldClass.voyageFlight + ' red-border' : fieldClass.voyageFlight"
                    tag-name="voyageNo"
                    tag-value="voyageNo"
                    :filter-tag-names="['voyageNo']"
                    @focus="pm.txtVoyageFocusInHandler()"
                    @parentCallBack="p=>{pm.onVoyageFlightChange(p)}"
                  />
                  <!--船期选择器-->
                  <span
                    v-show="isSelectVesselSchedule && this.action !== 'look'"
                    class="el-button el-button--primary el-button--mini"
                    style="min-width:40px!important;margin-left:2px"
                    @click="btnVayageShowHandle"
                  >
                    <i class="el-icon-search" />
                  </span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CarrierVoyage')">
                <el-input v-model="form.carrierVoyage" :class="importDifferenceField.carrierVoyage ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport || canEditInternalDelegatedJobField" no="carrierVoyage" />
              </el-form-item>
              <el-form-item label="S/O No." :class="fieldClass.soNoTitle">
                <so-no-input v-model="form.soNo" :disabled="readonlyExcludeExportToImport || slaveCustomsDeclarationEnable" :class="fieldClass.soNo" @blur="mblBlur(form.soNo, true)" />
              </el-form-item>
              <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.MblNo2')">
                <div style="display: flex;flex-direction: row;padding-right: 3px;">
                  <el-input v-show="[0, 2, 3].includes(isInputMbl)" v-model="form.mbl" no="7" :disabled="readonlyExcludeExportToImport" :class="form.mbl==='CANCELLED'?'mbl-red':''" @change="pm.changeMbl()" @blur="mblBlur" />
                  <el-input v-show="[1].includes(isInputMbl)" v-model="form.mbl" no="8" :disabled="readonlyExcludeExportToImport || !mblEditable" :class="form.mbl==='CANCELLED'?'mbl-red':''" @input="mblConfig.curRule = null" @change="pm.changeMbl()" @blur="mblBlur" />
                </div>
              </el-form-item>
              <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.BookingNo')">
                <el-input v-model="form.bookingNo" :disabled="readonlyExcludeExportToImport" no="9" />
              </el-form-item>
              <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.ShippingCompanyContractNo')">
                <!-- 只能手动输入 -->
                <el-input
                  v-if="sCNumberSelectMethod === 0"
                  v-model="form.scNo"
                  no="10"
                  :style="isTP ? 'width: 75%;display: inline-block' : ''"
                  :disabled="readonlyExcludeExportToImport"
                  :placeholder="$t('common.defaultPlaceholder')"
                />
                <!-- 只能选择 -->
                <cargo-advance-select
                  v-else-if="sCNumberSelectMethod === 1"
                  ref="scNoSelect"
                  no="10"
                  filterable
                  :style="isTP ? 'width: 75%;display: inline-block' : ''"
                  :allow-create="false"
                  :select-type="selectTypeNames.basic_data_ShippingContract"
                  :static-options="shippingContractList"
                  :tag-value="'contractNumber'"
                  :default-value="form.scNo"
                  :disabled="readonlyExcludeExportToImport"
                  :placeholder="$t('common.defaultPlaceholder')"
                  @parentCallBack="p=>{pm.onscNoChange(p)}"
                />
                <!-- 可以选择、可以手工输入 -->
                <cargo-advance-select
                  v-else
                  ref="scNoSelect"
                  no="10"
                  filterable
                  :style="isTP ? 'width: 75%;display: inline-block' : ''"
                  :allow-create="true"
                  :select-type="selectTypeNames.basic_data_ShippingContract"
                  :static-options="shippingContractList"
                  :tag-value="'contractNumber'"
                  :default-value="form.scNo"
                  :disabled="readonlyExcludeExportToImport"
                  :placeholder="$t('common.defaultPlaceholder')"
                  @parentCallBack="p=>{pm.onscNoChange(p)}"
                />
                <el-select
                  v-if="isTP"
                  v-model="form.scNoType"
                  :disabled="readonlyExcludeExportToImport"
                  no="flashPointUnit"
                  style="width: 25%;display: inline-block"
                  placeholder=""
                >
                  <el-option
                    v-for="(item,index) in scNoTypeArray"
                    :key="index"
                    :label="isZh ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <!--              <el-form-item :label="$t('SeaExport.InnerContractNo')">-->
              <!--                <el-input v-model="form.contractNo" />-->
              <!--              </el-form-item>-->
              <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.InnerContractNo')">
                <cargo-advance-select
                  ref="contractNo"
                  no="11"
                  :static-options="availableContractNos"
                  :cache="false"
                  :default-value="form.contractNo"
                  :disabled="readonlyExcludeExportToImport || !pm.lclslaveEnabledExcludeExportToImport"
                  filterable
                  clearable
                  :allow-create="true"
                  :class="importDifferenceField.contractNo ? fieldClass.contractNo + ' red-border' : fieldClass.contractNo"
                  tag-name="contractNo"
                  tag-value="contractNo"
                  :filter-tag-names="['contractNo']"
                  @parentCallBack="onContractNoChange"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.quotationNum')">
                <el-input v-model="form.quotationNum" :class="importDifferenceField.quotationNum ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport" no="12" />
              </el-form-item>
              <el-form-item label="IMO">
                <el-input v-model="form.vesselIMO" :class="importDifferenceField.vesselIMO ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport" no="13" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_CarrierCode')">
                <el-input v-model="form.carrierCode" :class="importDifferenceField.carrierCode ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport" no="carrierCode" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.BookingShipCallSign')">
                <el-input v-model="form.vesselCode" no="14" :class="importDifferenceField.vesselCode ? 'red-border' : ''" :disabled="readonlyExcludeExportToImport || !pm.lclslaveEnabledExcludeExportToImport" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode')">
                <el-input v-model="form.routeCode" no="95" :class="importDifferenceField.routeCode ? 'red-border' : ''" :disabled="checkRouteCode || readonly || !pm.lclslaveEnabledExcludeExportToImport" />
              </el-form-item>
              <el-form-item label="CNPT No.">
                <special-character-tip :texts="specialCharCheck.cNptNo">
                  <cargo-repeat-value-select
                    v-model="form.cNptNo"
                    :placeholder="''"
                    no="cNptNo"
                    filterable
                    :allow-create="true"
                    :disabled="readonlyExcludeExportToImport"
                    clearable
                    :options="cNptList"
                    label-field="no"
                    value-field="no"
                    unique-field="no"
                    :match-of-repeat-value="matchOfCNpt"
                    @change="cNptChangeHandler"
                    @handleBlur="cNptBlurHandler"
                  />
                </special-character-tip>
              </el-form-item>
              <el-form-item :label="''">
                <special-character-tip :texts="specialCharCheck.cNptName">
                  <el-input v-model="form.cNptName" :disabled="readonlyExcludeExportToImport" no="cNptName" type="textarea" :rows="3" />
                </special-character-tip>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_CustomerReserveVoyage')">
                <el-input v-model="form.customerReserveVoyage" :disabled="readonlyExcludeExportToImport" no="customerReserveVoyage" />
              </el-form-item>
              <el-form-item label="N/A">
                <div style="display: flex">
                  <cargo-advance-select
                    no="15"
                    :static-options="pm.nacList || []"
                    :cache="false"
                    :default-value="form.na"
                    :disabled="readonlyExcludeExportToImport"
                    filterable
                    clearable
                    :allow-create="true"
                    tag-name="nac"
                    tag-value="nac"
                    :filter-tag-names="['nac']"
                    @parentCallBack="p=>{form.na = p.value}"
                  />
                </div>
              </el-form-item>
              <el-form-item label="NOVCC">
                <el-input v-model="form.novcc" :disabled="readonlyExcludeExportToImport" no="novcc" />
              </el-form-item>
              <el-form-item label="LINE CODE">
                <el-input v-model="form.laneCode" :disabled="readonlyExcludeExportToImport" no="17" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CarrierSpecificCode')">
                <div style="display: flex">
                  <cargo-advance-select
                    ref="shippingCompanySpecificCode"
                    no="shippingCompanySpecificCode"
                    :static-options="shippingCompanySpecificCodeList"
                    :cache="false"
                    :default-value="form.shippingCompanySpecificCode"
                    :disabled="readonlyExcludeExportToImport"
                    filterable
                    clearable
                    :allow-create="true"
                    :class="importDifferenceField.shippingCompanySpecificCode ? fieldClass.shippingCompanySpecificCode + ' red-border' : fieldClass.shippingCompanySpecificCode"
                    tag-name="shippingCompanySpecificCode"
                    tag-value="shippingCompanySpecificCode"
                    :filter-tag-names="['shippingCompanySpecificCode']"
                    @parentCallBack="p=>{form.shippingCompanySpecificCode = p.value}"
                  />
                </div>
              </el-form-item>
            </div>
            <div>
              <span class="title">{{ $t('SeaExport.USAirlineInfo') }}</span>
              <el-form-item label="N/A CODE">
                <el-input v-model="form.naCode" :disabled="readonlyExcludeExportToImport" no="16" />
              </el-form-item>
              <el-form-item label="CODE">
                <el-input v-model="form.subContractNo" :disabled="readonlyExcludeExportToImport" no="18" />
              </el-form-item>
              <el-form-item label="TLI NO">
                <el-input v-model="form.tliNo" :disabled="readonlyExcludeExportToImport" no="tliNo" />
              </el-form-item>
            </div>
            <div>
              <span class="title">{{ $t('CargoMsg.Cargo_IndiaLineInfo') }}</span>
              <el-form-item :label="$t('CargoMsg.Cargo_CargoAmount')">
                <auto-number-input v-model="form.amount" :precision="2" :min="0" :disabled="readonlyExcludeExportToImport" no="amount" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_CargoCurrency')">
                <cargo-advance-select
                  no="currency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  filterable
                  :default-value="form.currency"
                  :disabled="readonlyExcludeExportToImport"
                  style="width:100%;"
                  @parentCallBack="p=>{form.currency=p.value}"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonlyExcludeExportToImport" label-width="150px" label-position="right">
            <span class="title">{{ $t('SeaExport.PolPortInfo') }}
              <!-- <el-tooltip class="item" effect="dark" :content="$t('SeaExport.PolPortInfoPrompt')" placement="top-start">
                <i class="el-icon-warning-outline" />
              </el-tooltip>-->
            </span>
            <!-- 港区 -->
            <el-form-item class="warn-label">
              <div slot="label" style="display: flex; float: right;">
                <el-button
                  v-if="shippingSchedules && shippingSchedules.length > 1"
                  :disabled="readonly"
                  no="showMoreShippingSchedules"
                  type="primary"
                  @click="showMoreShippingScheduleDialog"
                >{{ $t('CargoMsg.Cargo_ChooseShippingSchedules') }}
                </el-button>
                <span style="margin-left: 10px;">{{ $t('SeaExport.HarborDistrict') }}</span>
              </div>
              <el-input
                v-model="form.portDistrict"
                no="19"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                :class="fieldClass.portDistrict"
              />
            </el-form-item>
            <!-- 开港时间 -->
            <el-form-item class="warn-label" :label="$t('SeaExport.CYOpeningTime')">
              <el-date-picker
                v-model="form.terminalOpendate"
                no="20"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                :class="fieldClass.terminalOpendate"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 港区截港时间 -->
            <el-form-item class="warn-label" :label="$t('SeaExport.PortAreaCYCutOffTime')">
              <el-date-picker
                v-model="form.terminalCutoff"
                no="21"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                :class="fieldClass.terminalCutoff"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CarrierCyCutOffTime')">
              <el-date-picker
                v-model="form.carrierCyCutOffTime"
                no="22"
                :disabled="Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                :class="importDifferenceField.carrierCyCutOffTime ? 'red-border' : ''"
              />
            </el-form-item>
            <!-- 计划靠泊时间 --> <!-- 原始计划靠泊时间 -->
            <el-form-item class="warn-label" :label="isXycw ? $t('SeaExport.OriginalPlannedBerthingTime') : $t('SeaExport.PlannedBerthingTime')">
              <el-date-picker
                v-model="form.berthPlanDate"
                no="23"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                :class="fieldClass.berthPlanDate"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 计划离泊时间 --> <!-- 原始计划离泊时间 -->
            <el-form-item class="warn-label" :label="isXycw ? $t('SeaExport.OriginalPlanDepartureTime') : $t('SeaExport.PlanDepartureTime')">
              <el-date-picker
                v-model="form.unBerthPlanDate"
                no="24"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                :class="fieldClass.unBerthPlanDate"
                style="width: 100%"
              />
            </el-form-item>
            <!--当前计划靠泊时间-->
            <el-form-item v-if="isXycw" :label="$t('SeaExport.NowPlannedBerthingTime')">
              <el-date-picker
                v-model="form.currentETA"
                no="103"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                :class="fieldClass.berthPlanDate"
                style="width: 100%"
              />
            </el-form-item>
            <!--当前计划离泊时间-->
            <el-form-item v-if="isXycw" :label="$t('SeaExport.NowPlanDepartureTime')">
              <el-date-picker
                v-model="form.currentETD"
                no="104"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                :class="fieldClass.unBerthPlanDate"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际靠泊时间 -->
            <el-form-item class="warn-label" :label="$t('SeaExport.ActualBerthingTime')">
              <el-date-picker
                v-model="form.actualBerthPlanDate"
                no="25"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                :class="fieldClass.actualBerthPlanDate"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际离泊时间 -->
            <el-form-item class="warn-label" :label="$t('SeaExport.RealDepartureTime')">
              <el-date-picker
                v-model="form.actualUnBerthPlanDate"
                no="26"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                :class="fieldClass.actualUnBerthPlanDate"
                style="width: 100%"
                @input="actualUnBerthPlanDateChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlannedDockingBerths')">
              <el-input
                v-model="form.berthPlanPlace"
                no="27"
                :disabled="Boolean(form.lclMasterUuid)"
                :class="fieldClass.berthPlanPlace"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TheActualDockingBerths')">
              <el-input
                v-model="form.actualBerthPlanPlace"
                no="28"
                :disabled="Boolean(form.lclMasterUuid)"
                :class="fieldClass.actualBerthPlanPlace"
              />
            </el-form-item>
            <!-- 实际进港日期 -->
            <el-form-item :label="$t('SeaExport.ActualTimeOfArrivalThePort')">
              <el-date-picker
                v-model="form.realArrivalsDate"
                no="29"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                :class="fieldClass.realArrivalsDate"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EquipmentEstimatedReturnTimeFrom')">
              <el-date-picker
                v-model="form.returnPeriodBegin"
                no="30"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EquipmentEstimatedReturnTimeTo')">
              <el-date-picker
                v-model="form.returnPeriodEnd"
                no="31"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <span class="title">{{ $t('SeaExport.PodPortInfo') }}
              <el-popover
                placement="bottom"
                width="200"
                trigger="hover"
              >
                <div class="pop-content">{{ $t('CargoMsg.Cargo_PodPortInfoPrompt') }}</div>
                <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
              </el-popover>
            </span>
            <!-- 预计到港时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.EstimatedArrivalTime')">
              <el-date-picker
                v-model="form.estimatedArrivalTime"
                no="32"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际到港时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.ArrivalTime')">
              <el-date-picker
                v-model="form.actualArrivalTime"
                no="33"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                @input="actualArrivalTimeChangeHandler"
              />
            </el-form-item>
            <!-- 当前计划到港时间 -->
            <el-form-item v-if="isXycw && showButton" :label="$t('SeaExport.CurrentETA')">
              <el-date-picker
                v-model="form.currentArrivalTime"
                no="33"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计卸船时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.EstimatedPortDischargeTime')">
              <el-date-picker
                v-model="form.estimatedPortDischargeTime"
                no="estimatedPortDischargeTime"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际卸船时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.PortDischargeTime')">
              <el-date-picker
                v-model="form.portDischargeTime"
                no="34"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计铁路运输时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.EstimatedRailwayDepartureTime')">
              <el-date-picker
                v-model="form.estimatedRailwayDepartureTime"
                no="estimatedRailwayDepartureTime"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际铁路运输时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.RailwayDepartureTime')">
              <el-date-picker
                v-model="form.railwayDepartureTime"
                no="35"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计铁路卸货时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.EstimatedRailwayDischargeTime')">
              <el-date-picker
                v-model="form.estimatedRailwayDischargeTime"
                no="estimatedRailwayDischargeTime"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际铁路卸货时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.RailwayDischargeTime')">
              <el-date-picker
                v-model="form.railwayDischargeTime"
                no="36"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计抵达交货地时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.EstimatedTimeOfArrivalAtThePlaceOfDelivery')">
              <el-date-picker
                v-model="form.estimatedArrivalPlaceOfDelivery"
                no="estimatedArrivalPlaceOfDelivery"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际抵达交货地时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.TheActualTimeOfArrivalAtThePlaceOfDelivery')">
              <el-date-picker
                v-model="form.actualArrivalPlaceOfDelivery"
                no="actualArrivalPlaceOfDelivery"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计放关时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.EstimatedCustomsReleaseTime')">
              <el-date-picker
                v-model="form.estimatedCustomsReleaseTime"
                no="37"
                type="datetime"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际放关时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.ActualCustomsReleaseTime')">
              <el-date-picker
                v-model="form.destPortCustomsClearanceTime"
                no="38"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 目的港查验 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.DestinationPortInspection')">
              <el-switch
                v-model="form.destPortInspection"
                no="38-1"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
              />
            </el-form-item>
            <!-- 目的港查验等级 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.DestinationPortInspectionLevel')">
              <el-input
                v-model="form.destPortInspectionLevel"
                no="38-2"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
              />
            </el-form-item>
            <!-- 预计提重时间 -->
            <el-form-item v-show="showButton" class="warn-label" :title="$t('SeaExport.PickupMessage')" :label="$t('SeaExport.EstimatedPickupTime')">
              <el-date-picker
                v-model="form.estimatedPickUpTime"
                no="39"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际提重时间 -->
            <el-form-item v-show="showButton" class="warn-label" :title="$t('SeaExport.PickupMessage')" :label="$t('SeaExport.ActualPickUpTime')">
              <el-date-picker
                v-model="form.actualPickUpTime"
                no="40"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonlyExcludeExportToImport" label-width="110px" label-position="right">
            <span class="title">{{ $t('SeaExport.PODDeliveryInformation') }}</span>
            <el-form-item v-show="showButton" :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="form.estimatedDeliveryToWarehouseTime"
                no="41"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item v-show="showButton" :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="form.deliveryTime"
                no="42"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item v-show="showButton" :title="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="form.destPortDeliveryTime"
                no="43"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.ActualDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="form.deliveryCompletionDate"
                no="44"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.EstimatedDeliveryTime')">
              <el-date-picker
                v-model="form.estDeliveryTime"
                no="41"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.ActualDeliveryTime')">
              <el-date-picker
                v-model="form.actDeliveryTime"
                no="42"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 预计还空时间 -->
            <el-form-item class="warn-label" :label="$t('SeaExport.EstimatedReturnTime')">
              <el-date-picker
                v-model="form.estimatedReturnTime"
                no="45"
                type="datetime"
                :disabled="editPermissions"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 实际还空时间 -->
            <el-form-item v-show="showButton" class="warn-label" :label="$t('SeaExport.ActualReturnTime')">
              <el-date-picker
                v-model="form.destPortReturnTime"
                no="46"
                :disabled="editPermissions || Boolean(form.lclMasterUuid)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
            <el-form-item :label="$t('SeaExport.CyCode')">
              <el-input v-model="form.yardCode" no="47" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortCodeOfDischarge')">
              <el-input v-model="form.portCode" no="48" :class="importDifferenceField.portCode ? 'red-border' : ''" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EquipmentReceiptAddress')">
              <el-input v-model="form.addressEIR" type="textarea" :rows="3" no="49" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EquipmentReceiptContactPerson')">
              <el-input v-model="form.contactEIR" no="50" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EquipmentReceiptContactWay')">
              <el-input v-model="form.phoneEIR" no="51" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocCutOffDate')">
              <el-date-picker
                v-model="form.fileCutoff"
                no="52"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                :class="importDifferenceField.fileCutoff ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DeclareCutOffDate')">
              <el-date-picker
                v-model="form.declareCutOff"
                no="53"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                :class="importDifferenceField.declareCutOff ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CYCutOffDate2')">
              <el-date-picker
                v-model="form.customCutoff"
                no="54"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                :class="importDifferenceField.customCutoff ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerCyCutOffDate')">
              <el-date-picker
                v-model="form.customerCutoff"
                no="55"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                :class="importDifferenceField.customerCutoff ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerShutOutDate')">
              <el-date-picker
                v-model="form.customerShutout"
                no="56"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerClosingTime')">
              <el-date-picker
                v-model="form.customerFileCutoff"
                no="56"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                :class="importDifferenceField.customerFileCutoff ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item v-show="form.ams" :label="$t('SeaExport.AmsEnsCyCutOffDate')">
              <el-date-picker
                v-model="form.amsCutoff"
                no="57"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="AP CODE">
              <el-input v-model="form.apCode" no="58" :class="importDifferenceField.apCode ? 'red-border' : ''" />
            </el-form-item>
            <el-form-item label="AP NAME">
              <el-input v-model="form.apName" no="59" :class="importDifferenceField.apName ? 'red-border' : ''" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDetension')">
              <el-input-number
                v-model="form.freeTime"
                no="60"
                :controls="false"
                class="align-left"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item v-show="showButton" :label="$t('SeaExport.CargoReadyDate')">
              <el-date-picker
                v-model="form.estimatedPackDate"
                no="61"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ArrivalTime2')">
              <el-date-picker
                v-model="form.arrivalTime"
                no="62"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item
              v-show="showEntrustmentState"
              :label="$t('SeaExport.ConsignationStatus')"
            >
              <el-input
                :disabled="true"
                :value="textEntrustmentState"
                style="width:155px"
                @dblclick.native="pm.entrustHisBtnClickHandler()"
              />
              <cargo-button-container>
                <el-button
                  type="primary"
                  style="margin-left:2px"
                  @click="pm.entrustHisBtnClickHandler()"
                >...</el-button>
              </cargo-button-container>
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form class="form-card" :disabled="readonlyExcludeExportToImport" label-width="130px" label-position="right" style="height:100%">
            <!-- 海运二程信息 -->
            <span class="title">{{ $t('SeaExport.SecondVesselInfo') }}</span>
            <el-form-item :label="$t('SeaExport.Vessel')" :class="fieldClass.secondVesselVoyageTitle">
              <el-input v-model="form.secondVesselVoyage" no="63" :class="fieldClass.secondVesselVoyage" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SecondVoyage')" :class="fieldClass.secondVoyageTitle">
              <el-input v-model="form.secondVoyage" no="64" :class="fieldClass.secondVoyage" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfDeparture')">
              <el-date-picker v-model="form.secondVesselETD" no="65" type="date" value-format="yyyy-MM-dd" style="width: 100%" @input="secondVesselETDChange" />
            </el-form-item>
            <!-- 起运港 -->
            <el-form-item :label="$t('CargoMsg.Cargo_SecondPolCode')">
              <cargo-advance-select
                ref="secondPolCode"
                no="secondPolCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.secondPolCode"
                tag-name="englishName"
                style="flex:1"
                @parentCallBack="p=>{form.secondPolCode=p.value;form.secondPol=p.englishName;}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PortOfLoading')">
              <el-input v-model="form.secondPol" no="secondPol" />
            </el-form-item>
            <!-- 目的港 -->
            <el-form-item :label="$t('CargoMsg.Cargo_SecondPodCode')">
              <cargo-advance-select
                ref="secondPodCode"
                no="secondPodCode"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.secondPodCode"
                tag-name="englishName"
                style="flex:1"
                @parentCallBack="p=>{form.secondPodCode=p.value;form.secondPod=p.englishName;}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
              <el-input v-model="form.secondPod" no="secondPod" />
            </el-form-item>
            <!-- 中转抵港 -->
            <el-form-item :label="$t('SeaExport.SecondArrivalTime')" class="warn-label">
              <el-date-picker v-model="form.secondArrivalsDate" no="secondArrivalsDate" :disabled="editPermissions" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <!-- 中转卸船 -->
            <el-form-item :label="$t('SeaExport.SecondUnloadingTime')" class="warn-label">
              <el-date-picker v-model="form.secondUnloadingDate" no="secondUnloadingDate" :disabled="editPermissions" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <!-- 中转装船 -->
            <el-form-item :label="$t('SeaExport.SecondLoadingTime')" class="warn-label">
              <el-date-picker v-model="form.secondLoadingDate" no="secondLoadingDate" :disabled="editPermissions" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <!-- 中转开航 -->
            <el-form-item :label="$t('SeaExport.SecondDepartureTime')" class="warn-label">
              <el-date-picker v-model="form.secondShipmentDate" no="secondShipmentDate" :disabled="editPermissions" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransferModeAtTransferPoint')">
              <cargo-multi-select v-model="form.fnlTm" no="66" :disabled="readonlyExcludeExportToImport">
                <el-option
                  v-for="(item,index) in FNL_TM"
                  :key="index"
                  :label="item.englishName"
                  :value="item.code"
                />
              </cargo-multi-select>
            </el-form-item>
            <!-- 支线驳船信息 -->
            <span class="title">{{ $t('SeaExport.BargeInfo') }}</span>
            <!-- 支线开航日期 -->
            <el-form-item :label="$t('SeaExport.branchLineDateOfDeparture')" class="warn-label">
              <el-date-picker v-model="form.bargeETD" :disabled="editPermissions" no="67" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <!-- 支线到岗日期 -->
            <el-form-item :label="$t('SeaExport.branchLineDateOfArrival')" class="warn-label">
              <el-date-picker v-model="form.bargeETA" :disabled="editPermissions" no="68" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Vessel')">
              <el-input v-model="form.bargeVessel" no="69" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Voyage')">
              <el-input v-model="form.bargeVoyage" no="70" @focus="form.bargeVoyage=form.bargeVoyage||'V.'" />
            </el-form-item>
            <!-- 起运港（POR） -->
            <el-form-item :label="$t('SeaExport.PortOfLoadingPOR')">
              <el-input v-model="form.bargePOL" no="71" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDestination')">
              <el-input v-model="form.bargePOD" no="72" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ServiceCode')">
              <el-input v-model="form.vesselLineCode" no="73" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CYCutOffDate2')">
              <el-date-picker
                v-model="form.bargeCustomCutoff"
                no="74"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.RiverCarrier')">
              <cargo-company-select
                no="75"
                :method-params="{seaCmp:true}"
                :default-value="form.riverCarrierId||''"
                @change="p=>{form.riverCarrierId=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="form.bargeRemarks"
                no="bargeRemarks"
                type="textarea"
                :rows="2"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.bargeRemarks,val=>{form.bargeRemarks=val})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div v-if="enableShipperConsignNotify" class="section form-column">
          <el-form
            :disabled="readonlyExcludeExportToImport"
            label-width="70px"
            label-position="right"
            style="height:100%"
          >
            <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
            <el-form-item class="auto-width">
              <span slot="label">{{ $t('SeaExport.Shipper') }}</span>
              <div style="display: flex;width: 100%">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="shipperCode"
                  v-model="mblCargoDoc.shipperCode"
                  :disabled="enableShipperLocked"
                  no="shipperCode"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  no="shipperId"
                  :disabled="enableShipperLocked"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ shipper: true, active: true }"
                  filterable
                  :default-value="mblCargoDoc.shipperId||''"
                  style="flex:1"
                  @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
                />
                <el-button
                  no="reset"
                  :disabled="enableShipperLocked"
                  type="primary"
                  style="margin-left: 5px"
                  @click="pm.onClear(1)"
                >{{ $t('SeaExport.Reset') }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'shipperLine'+count"
              class="auto-width"
            >
              <special-character-tip :texts="specialCharCheck['shipperLine'+count]">
                <cargo-input
                  :ref="'shipperLine'+count"
                  v-model="mblCargoDoc['shipperLine'+count]"
                  :disabled="enableShipperLocked"
                  :no="'shipperLine'+count"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @dblclick.native="showShipperDialog"
                  @change="()=>wrapAddr(mblCargoDoc,'shipperLine'+count,count+1 > 7 ? null :'shipperLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label">{{ $t('SeaExport.Consignee') }}</span>
              <div style="display: flex;width: 100%">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="consigneeCode"
                  v-model="mblCargoDoc.consigneeCode"
                  :disabled="enableShipperLocked"
                  no="19"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  no="consigneeId"
                  :disabled="enableShipperLocked"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ consignee: true, active: true }"
                  filterable
                  :default-value="mblCargoDoc.consigneeId||''"
                  style="flex:1"
                  @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
                />
                <el-button
                  no="reset"
                  type="primary"
                  :disabled="enableShipperLocked"
                  style="margin-left: 5px"
                  @click="pm.onClear(2)"
                >{{ $t('SeaExport.Reset') }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'consigneeLine'+count"
              class="auto-width"
            >
              <special-character-tip :texts="specialCharCheck['consigneeLine'+count]">
                <cargo-input
                  :ref="'consigneeLine'+count"
                  v-model="mblCargoDoc['consigneeLine'+count]"
                  :disabled="enableShipperLocked"
                  :no="'consigneeLine'+count"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @dblclick.native="showConsigneeDialog"
                  @change="()=>wrapAddr(mblCargoDoc,'consigneeLine'+count,count+1 > 7 ? null :'consigneeLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label">{{ $t('SeaExport.NotifyParty') }}</span>
              <div>
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="notifyCode"
                  v-model="mblCargoDoc.notifyCode"
                  :disabled="enableShipperLocked"
                  no="notifyCode"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  no="notifyId"
                  :disabled="enableShipperLocked"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ notify: true, active: true }"
                  filterable
                  :default-value="mblCargoDoc.notifyId||''"
                  @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
                />
                <div style="margin-top: 5px">
                  <el-button
                    no="reset"
                    type="primary"
                    :disabled="enableShipperLocked"
                    @click="pm.onClear(3)"
                  >{{ $t('SeaExport.Reset') }}
                  </el-button>
                  <el-button
                    no="copyConsignee"
                    type="primary"
                    :disabled="enableShipperLocked"
                    style="margin-left: 5px"
                    @click="pm.onCopyConsignee()"
                  >{{ $t('SeaExport.CopyTheConsignee') }}
                  </el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'notifyLine'+count"
              class="auto-width"
            >
              <special-character-tip :texts="specialCharCheck['notifyLine'+count]">
                <cargo-input
                  :ref="'notifyLine'+count"
                  v-model="mblCargoDoc['notifyLine'+count]"
                  :no="'notifyLine'+count"
                  :disabled="enableShipperLocked"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @dblclick.native="showNotifyDialog"
                  @change="()=>wrapAddr(mblCargoDoc,'notifyLine'+count,count+1 > 7 ? null :'notifyLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section" style="width:100%">
        <span class="title">{{ $t('SeaExport.ModulesInfo') }}</span>
        <div class="form-row" style="display:flex;flex-direction:row;">
          <el-form :disabled="readonlyExcludeExportToImport" :inline="true" label-width="160px" label-position="right">
            <el-form-item :label="$t('SeaExport.ShippingAdviceRemark')">
              <el-input
                v-model="form.remarksShipping"
                no="76"
                type="textarea"
                :rows="5"
                style="width:395px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ShippingAdviceRemark'),form.remarksShipping,val=>{form.remarksShipping=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingConfirmationRemarks')">
              <el-input
                v-model="form.remarksBooking"
                no="77"
                type="textarea"
                :rows="5"
                style="width:395px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.BookingConfirmationRemarks'),form.remarksBooking,val=>{form.remarksBooking=val})"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="isTP" class="section" style="width:100%">
        <span class="title">{{ $t('CargoMsg.Cargo_MultiLegVoyageManagement') }}</span>
        <div class="form-row" style="flex-direction:row;">
          <div style="display:flex;padding-bottom: 5px">
            <el-button
              no="add"
              type="primary"
              :disabled="readonly"
              @click="addClickHandler"
            >{{ $t('CargoMsg.Cargo_Add') }}
            </el-button>
            <el-button
              no="delete"
              type="danger"
              :disabled="readonly"
              @click="deleteClickHandler"
            >{{ $t('CargoMsg.Cargo_Delete') }}
            </el-button>
          </div>
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="leg.gridOptions"
            :column-defs="columnDefs"
            grid-style="height:100%;"
            :row-data="leg.rowData"
            @gridReady="params=>leg.gridApi=params.api"
          />
        </div>
      </div>
      <div v-if="ediReceipt.showEdiReceipt" class="section">
        <span class="title">{{ $t('SeaExport.BookingReceipt') }} ({{ $t('SeaExport.InMailOfThePrevail') }})</span>
        <booking-confirmation
          :edi-receipt-data="ediReceipt.data"
          :job-no="pm.job.jobNo"
          @syncBC="syncBC"
        />
      </div>
      <div v-if="ediReceiptCommon.showEdiReceipt" class="section">
        <span class="title">{{ $t('SeaExport.BookingReceipt') }}</span>
        <booking-confirmation-common
          :edi-receipt-data="ediReceiptCommon.data"
          :job-no="pm.job.jobNo"
          :job="pm.job"
          :last-receipt-time="ediReceiptCommon.data[0].time"
          @showYdBookingResult="$emit('showYdBookingResult', 'tabVesselEq')"
        />
      </div>
    </div>
    <!--  特殊元素, 隐藏, 用于简单上传触发系统文件选择弹窗  -->
    <input ref="importFile" type="file" accept=".pms" style="display:none;" @change="onImportFile">
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" :disabled="readonlyExcludeExportToImport" type="textarea" rows="10" />
      <span slot="footer">
        <el-button v-show="isEditExcludeExportToImport" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通高级文本弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="transAdvanceTextDialog.visible"
      :title="transAdvanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="transAdvanceTextDialog.value" :disabled="readonlyExcludeExportToImport || enableShipperLocked" type="textarea" rows="10" />
      <span slot="footer">
        <el-button v-show="isEditExcludeExportToImport" type="primary" @click="finishTransAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="transAdvanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!-- 校验船期数据是否变更弹窗 -->
    <el-dialog
      :title="$t('SeaExport.tips')"
      :visible.sync="vesseldialog"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-indent:2em;font-size:14px;line-height: 1.5;letter-spacing: 0.5px;">{{ $t('SeaExport.ObtainedContainerAndGoodsData') }}
        <span style="color:red;font-size:14px;">{{ $t('Message.ShipName') }}{{ jobDataVessel ? jobDataVessel : $t('SeaExport.empty') }}、{{ $t('SeaExport.Sailing') }}{{ jobDataVoyageFlight ? jobDataVoyageFlight : $t('SeaExport.empty') }}</span>{{ $t('SeaExport.WithBookingTab') }}
        <span style="color:red;font-size:14px;">{{ $t('Message.ShipName') }}{{ shippingDate.vessel ? shippingDate.vessel : $t('SeaExport.empty') }}、{{ $t('SeaExport.Sailing') }}{{ shippingDate.voyageFlight ? shippingDate.voyageFlight : $t('SeaExport.empty') }}</span>
        {{ $t('SeaExport.InconsistentFromTheBillData') }}
        <br>
        <span style="font-size:14px;">{{ $t('SeaExport.InconsistentFromTheBillDataTips') }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeVessel('empty')">{{ $t('SeaExport.importEmpty') }}</el-button>
        <el-button type="primary" @click="changeVessel('notEmpty')">{{ $t('SeaExport.importNotEmpty') }}</el-button>
        <el-button @click="changeVessel('ignore')">{{ $t('SeaExport.ignore') }}</el-button>
      </span>
    </el-dialog>
    <cross-tenant-history-dialog
      :visible.sync="crossTenantHistoryDialog.visible"
      :entrustment-type="crossTenantHistoryDialog.entrustmentType"
      :job-no="crossTenantHistoryDialog.jobNo"
    />
    <!-- api接口选择弹窗 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      :is-hz="isHZ"
      @selectedApi="selectedApiCallback"
    />
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :error-log="errorLogDialog.errorLog"
    />
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="getEDICallback"
    />
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
      @uploadSuccess="uploadSuccessHandler"
    />
    <multi-seg-num-rules-dialog
      :visible.sync="multiSegNumRulesDialog.visible"
      @callback="multiSegNumRulesCallback"
    />

    <generate-mbl-no-dialog
      :visible="mblConfig.visible"
      :form="form"
      :config="mblConfig"
      @close="mblConfig.visible =false"
    />
    <generate-so-no-dialog
      :visible="soNoConfig.visible"
      :form="form"
      :config="soNoConfig"
      :input-mbl="isInputMbl"
      :mbl-config="mblConfig"
      @close="soNoConfig.visible =false"
    />
    <edi-guide-window
      v-if="ediBaseWindow.visible"
      ref="ediBaseWindow"
      :do-saving="doSaving"
      :global-var="globalVar"
      :visible="ediBaseWindow.visible"
      :call-back-func="ediBaseWindow.callBackFunc"
      :context="context"
      @close="ediBaseWindow.visible =false"
      @ediChangeHandler="ediChangeHandler"
    />
    <!-- 订舱日志 -->
    <booking-log-dialog
      v-if="bookingLogDialog.visible"
      :visible="bookingLogDialog.visible"
      :job-uuid="bookingLogDialog.jobUuid"
      :send-type="bookingLogDialog.sendType"
      :is-hz="isHZ"
      @close="bookingLogDialog.visible=false"
    />
    <!--    edi-type="1"-->
    <!-- 选择船期 -->
    <choose-shipping-schedules
      v-if="showMoreShippingSchedule"
      :visible="showMoreShippingSchedule"
      :job="form"
      :shipping-schedules="shippingSchedules"
      :choose-shipping-schedule="chooseShippingSchedule"
      :is-btn="isChooseShippingScheduleBtn"
      @close="closeMoreShippingScheduleDialog"
    />
    <!--船期选择器-->
    <shipping-schedule-dialog
      ref="voyageShowDialog"
      :visible.sync="voyageShowDialog"
      :callback="callbackShippingScheduleHanle"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="form.lob"
      :job="form"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
    />
    <el-dialog
      :visible.sync="showRouteDialog"
      :title="this.$t('common.btn.confirm')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 16px;">{{ this.routeTitle }}</div>
      <el-radio-group v-model="selectedRoute">
        <el-radio v-for="item in routeOptions" :key="item" :label="item">{{ item }}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onRouteDialogConfirm">{{ this.$t('common.btn.confirm') }}</el-button>
        <el-button @click="showRouteDialog = false">{{ this.$t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabVesselEqPM } from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEqPM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoMultiSelect from '@/components/Cargo/Common/cargoMultiSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import crossTenantHistoryDialog from '../crossTenantHistoryDialog'
import errorLogDialog from '@/views/cargo/v0/SeaExport/components/edi/errorLogDialog'
import dialogSelector from '@/views/cargo/v0/SeaExport/components/edi/dialogSelector'
import messagePreviewDialog from '@/views/cargo/v0/SeaExport/components/edi/messagePreviewDialog'
import cargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { FNL_TM } from '@/class/cargo/model/parameters/SeaExportConstants'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as ediApi from '@/api/seaExport/edi'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import { savePmsFile } from '@/api/seaExport/poItems'
import { checkCreditInfo } from '@/api/partner/creditInfo'
import * as jobApi from '@/api/seaExport/seaExportJob'
import { MBL } from '@/class/cargo/model/parameters/CargoDocConsts'
import * as trackingApi from '@/api/sysManage/baseConfig/businessManage'
import multiSegNumRulesDialog from '@/views/cargo/v0/SeaExport/components/edi/multiSegNumRulesDialog'
import GenerateMblNoDialog from '@/views/cargo/v0/SeaExport/components/booking/GenerateMblNoDialog'
import GenerateSoNoDialog from '@/views/cargo/v0/SeaExport/components/booking/tabs/GenerateSoNoDialog'
import checkPermission from '@/utils/permission'
import { allocateSoNo } from '@/api/seaExport/mbl'
import ApiPopup from '@/views/cargo/v0/SeaExport/components/edi/apiPopup'
import StrUtils from '@/utils/StrUtils'
import BookingLogDialog from '@/views/cargo/v0/SeaExport/components/edi/bookingLogDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import DateUtils from '@/utils/dateUtils'
import { queryShippingSchedule, getVesselChangeStatus, changeVesselChangeStatus, loadingShipTime } from '@/api/voyage'
import { loadSpecificBasicInfo } from '@/api/cache'
import BookingConfirmation from '@/views/cargo/v0/SeaExport/components/booking/tabs/BookingConfirmation'
import BookingConfirmationCommon from '@/views/cargo/v0/SeaExport/components/booking/tabs/BookingConfirmationCommon'
import ediGuideWindow from '@/views/cargo/v0/SeaExport/components/booking/tabs/leadPage/ediGuideWindow'
import { queryEdiReceipts, syncBc } from '@/api/booking/job'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import { cache, cacheName } from '@/utils/cacheManager'
import { dateCompare, DocumentManage } from '@/utils/commonUtil'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import ChooseShippingSchedules from '@/views/cargo/v0/SeaExport/components/booking/tabs/chooseShippingSchedules'
import { getOpening, getShippingScheduleDistrict } from '@/api/seaExport/dataTracking'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'
import { addCNpt, getCNptFunc } from '@/api/company'
import { checkReminderFunc } from '@/api/booking/mblManagement'
import shippingScheduleDialog from '@/components/Cargo/Job/shippingScheduleDialog.vue'
import { getObjectByCache } from '@/utils/basicDataCache'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { TabBookingFCLPM } from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCLPM'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import {
  RECEIPT_SOURCE_EMAIL,
  RECEIPT_SOURCE_HPL,
  JOB_BOOKING_STATE_BOOKING,
  RECEIPT_SOURCE_YD,
  CHANNEL_0
} from '@/class/cargo/model/parameters/SystemConstants'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow.vue'
import { canSubscribeReceipt, subscribeReceiptExec } from '@/api/seaExport/edi'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { MultiLegVoyageManagement } from '@/class/model/booking/MultiLegVoyageManagement'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index.vue'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index.vue'
import { getUuid } from '@/utils'
import { Voyage } from '@/class/model/mdm/Voyage'
import { syncAtdInfo } from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceUtil'

export default {
  name: 'TabVesselEq',
  components: {
    CheckingWindow,
    ChooseShippingSchedules,
    BookingLogDialog,
    ApiPopup,
    BookingConfirmation,
    BookingConfirmationCommon,
    GenerateSoNoDialog,
    GenerateMblNoDialog,
    cargoAdvanceSelect,
    cargoMultiSelect,
    cargoCompanySelect,
    soNoInput,
    crossTenantHistoryDialog,
    errorLogDialog,
    dialogSelector,
    ediGuideWindow,
    messagePreviewDialog,
    multiSegNumRulesDialog,
    cargoButtonContainer,
    cargoInput,
    cargoRichTextarea,
    specialCharacterTip,
    cargoRepeatValueSelect,
    shippingScheduleDialog,
    AutoNumberInput
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    showButton: { // 显示关联业务进来为false
      type: Boolean,
      default: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    doSaving: { // 保存过程中
      type: Boolean,
      default: false
    },
    slaveCustomsDeclarationEnable: { // 【小票】关单信息 是否可用
      type: Boolean,
      default: false
    },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      editPermissions: false, SystemConstants,
      isZh: this.$store.getters.language === 'zh',
      jobDataVessel: '',
      jobDataVoyageFlight: '',
      text: '',
      isXycw: false,
      vesslPlanUpdate: false,
      shippingDate: {
        vessel: '',
        voyageFlight: ''
      },
      jobUuid: '',
      shippingContractList: [],
      legVoyageList: [],
      voyageMap: new Map(),
      vesseldialog: false,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabVesselEqPM(this),
      FNL_TM,
      selectTypeNames: TYPE_NAMES,
      partnerManagementMode: 0,
      bookingEDIApiOpen: false,
      seAllowReceiptImport: false,
      showBookingEdi1: false,
      showResubscribeBookingReceipt: false,
      bookingEdi1Disabled: false,
      canSubscribeReceipt: false, // 是否可以创建订阅回执
      isCrossTenant: false,
      checkRouteCode: true, // 是否可以编辑航线代码
      form: new SeaExportJob().fillDefaultValue().getData(),
      textEntrustmentState: '',
      shippingCompanySpecificCodeList: [],
      fieldClass: {
        vessel: '',
        voyageFlight: '',
        portDistrict: '',
        terminalOpendate: '',
        terminalCutoff: '',
        unBerthPlanDate: '',
        actualUnBerthPlanDate: '',
        berthPlanDate: '',
        actualBerthPlanDate: '',
        berthPlanPlace: '',
        actualBerthPlanPlace: '',
        vesselTitle: '',
        voyageFlightTitle: '',
        soNo: '',
        soNoTitle: '',
        secondVesselVoyage: '',
        secondVesselVoyageTitle: '',
        secondVoyage: '',
        secondVoyageTitle: '',
        realArrivalsDate: ''
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      crossTenantHistoryDialog: {
        visible: false,
        entrustmentType: '',
        jobNo: ''
      },
      globalVar: {
        // 业务参数
        selectedJob: null,
        selectedJobKey: null,
        selectedJobs: null,
        selectedJobKeys: null,
        title: '',
        ediType: 0,
        shutOutIdentification: 0,
        editStatus: 0,
        ediTemplate: null,
        ediDatas: null,
        ediTemplateWin: { uuids: null, item: null },
        // 控制参数
        popMultiSegNumRulesType: 1, // 多段参数规则弹窗类型 1:订舱操作引用弹窗 2: 舱单操作引用弹窗
        ediStatusName: '', // 记录按钮发送操作
        sendRPA: false // 发送壹沓RAP
      },
      // 错误日志显示弹窗
      errorLogDialog: {
        visible: false,
        errorLog: ''
      },
      // edi弹窗选择器
      selectorDialog: {
        key: '',
        visible: false,
        title: this.$t('SeaExport.BookingEDI'),
        rowData: []
      },
      // 报文预览弹窗
      messagePreviewDialog: {
        visible: false,
        params: {}
      },
      multiSegNumRulesDialog: {
        visible: false
      },
      mblConfig: {
        visible: false,
        rule: '',
        identificationCode: '',
        curRule: null
      },
      ediBaseWindow: {
        callBackFunc: null,
        visible: false
      },
      soNoConfig: {
        visible: false,
        ruleType: '',
        split: '',
        generateCount: ''
      },
      bookingLogDialog: {
        visible: false,
        jobUuid: '',
        sendType: ''
      },
      ediReceipt: {
        showEdiReceipt: false,
        data: []
      },
      ediReceiptCommon: {
        showEdiReceipt: false,
        data: []
      },
      apiPopup: { // api弹框
        visible: false,
        title: '',
        state: '',
        interfaceType: 1,
        interfaceArray: ''
      },
      isInputMbl: 0, // 是否允许手动输入MBL,默认允许
      showJudgmentOfVoyageNo: false, // 航次是否显示V.判断
      combinedManifest: false, // 控制船名航次下拉数据，锦昶使用
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null,
        shipperLine1: null,
        shipperLine2: null,
        shipperLine3: null,
        shipperLine4: null,
        shipperLine5: null,
        shipperLine6: null,
        consigneeLine1: null,
        consigneeLine2: null,
        consigneeLine3: null,
        consigneeLine4: null,
        consigneeLine5: null,
        consigneeLine6: null,
        notifyLine1: null,
        notifyLine2: null,
        notifyLine3: null,
        notifyLine4: null,
        notifyLine5: null,
        notifyLine6: null,
        cNptNo: null,
        cNptName: null
      },
      synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false,
      maxChars: 34,
      warningCount: 0,
      isUppercase: true,
      masterFlag: false,
      isCarrierUserMSC: false,
      mblCargoDoc: new SeaCargoDoc().fillDefaultValue().getData(),
      enableShipperConsignNotify: false, // 是否显示收发通
      isHZ: false, // 宏真对接民生使用
      isTP: false, // 对接太平使用
      sCNumberSelectMethod: 0, // CARGO-54179 约号管理
      mblManager: null, // 主单号管理唯一标识
      enableShipperLocked: false, // 是否禁用收发通
      transAdvanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      oldVessel: '',
      oldVoyageFlight: '',
      cleanFlag: false,
      contractNos: [],
      hasChooseShippingSchedule: false,
      chooseShippingSchedule: '',
      shippingSchedules: [],
      showMoreShippingSchedule: false,
      isChooseShippingScheduleBtn: false,
      leg: {
        gridApi: null,
        addKey: 'addLeg_',
        delMultiLegVoyageManagement: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridDateTimeEditor
          },
          context: {
            componentParent: this
          }
        },
        rowData: []
      },
      documentManage: new DocumentManage(),
      cNptList: [],
      matchOfCNpt: options => {
        const option = options.find(p => p.no === this.form.cNptNo)
        return option || options[0]
      },
      fclPm: new TabBookingFCLPM(this),
      voyageShowDialog: false,
      voyageShowDialogData: {
        etd: '',
        vesselId: '',
        voyageNo: '',
        loadingPortCode: '',
        legUuid: '',
        transferPortCode: false,
        transfering: false,
        dischargingPortCode: '',
        routeCode: ''
      },
      openPortDataService: 0,
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null
      },
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      showRouteDialog: false, // 航线选择弹窗显示控制
      routeOptions: [], // 航线选项数组
      routeTitle: '', // 航线提示语
      selectedRoute: '', // 当前选中的航线
      scNoTypeArray: SeaExportConstants.SC_NO_TYPES
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return (this.form.relatedJob && !this.isCrossTenant) || this.action === 'look' || (this.action !== 'look' && !!this.form.uuid && !checkPermission(['tab_SEBooking_EditVesselEqTab']))
    },
    // CARGO-29261 出口转进口后，订舱页签船名航次无法更改
    readonlyExcludeExportToImport() {
      if (!this.cooperateEdit) return true
      return (this.form.relatedJob && !this.isCrossTenant && this.form.relatedJobLob !== 'SI') || this.action === 'look' || (this.action !== 'look' && !!this.form.uuid && !checkPermission(['tab_SEBooking_EditVesselEqTab']))
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return (!this.form.relatedJob || this.isCrossTenant) && this.action !== 'look' && (!this.form.uuid || (this.form.uuid && checkPermission(['tab_SEBooking_EditVesselEqTab'])))
    },
    // CARGO-29261 出口转进口后，订舱页签船名航次无法更改
    isEditExcludeExportToImport() {
      if (!this.cooperateEdit) return false
      return (!this.form.relatedJob || this.isCrossTenant || (this.form.relatedJobLob === 'SI')) && this.action !== 'look' && (!this.form.uuid || (this.form.uuid && checkPermission(['tab_SEBooking_EditVesselEqTab'])))
    },
    readonlyVessel() {
      if (!this.cooperateEdit) return true
      return (this.form.relatedJob && !this.isCrossTenant) || this.action === 'look' || (this.action !== 'look' && !!this.form.uuid && !checkPermission(['tab_SEBooking_EditVesselEqTab']))
    },
    showVessel() {
      return ((this.form.lob === 'SE') && (this.viewSource === 'bookingWorkspace' || this.viewSource === 'verifyWorkspace') && (this.form && !this.form.lclMasterUuid) && !this.isFba)
    },
    showEntrustmentState() {
      return (this.form.relatedJob || this.form.trustFromJob) && this.pm.isCrossJob
    },
    config() {
      return this.context.config
    },
    mblEditable() {
      return !checkPermission(['button_SEBooking_generateMBL'])
    },
    controlVessel() { // CARGO-17017 船名航次根据基本界面填写的起运港目对比船期带出
      return this.combinedManifest && Number(this.pm.editVesselVoyageMode) === 1 && Number(this.pm.editVoyageMode) === 1
    },
    isFba() { // 是否是FBA业务
      return this.form.fba
    },
    enableShipperLock() {
      return this.readonly || !this.form.signMBL
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    // 可用的的内部约号
    availableContractNos() {
      const result = []
      const unqiueSet = new Set()
      for (const item of this.contractNos) {
        if (this.form.etd) {
          if (dateCompare(this.form.etd, item.beginDate) < 0 || dateCompare(this.form.etd, item.endDate) > 0) {
            continue
          }
        }
        if (unqiueSet.has(item.contractNo)) {
          continue
        }
        result.push(item)
        unqiueSet.add(item.contractNo)
      }
      return result
    },
    canEditInternalDelegatedJobField() { // 是否可以编辑内部委托业务字段
      return this.config && Number(this.config.get('InternalCrossJobSynchronization')) === 1 &&
        this.job && this.job.relatedJob && this.job.relatedJobLob && this.job.relatedJobLob === 'SE'
    },
    isSelectVesselSchedule() { // 可使从船期表选择船名航次 0=不开启， 1=开启
      return this.config && Number(this.config.get('SelectVesselSchedule')) === 1
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.Voyage2'),
          field: 'leg',
          width: 100,
          valueFormatter: (params) => {
            return this.legData(Number(params.value))
          }
        },
        {
          headerName: this.$t('SeaExport.LoadingPort'), field: 'pol', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'code')
          },
          editable: !this.readonly,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: true,
              selectType: TYPE_NAMES.basic_data_Seaport,
              tagValue: 'code',
              tagName: 'code',
              filterable: true
            }
          }
        },
        {
          headerName: this.$t('SeaExport.dischargingPort'), field: 'pod', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'code')
          },
          editable: !this.readonly,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: true,
              selectType: TYPE_NAMES.basic_data_Seaport,
              tagValue: 'code',
              tagName: 'code',
              filterable: true
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'), field: 'vessel', width: 150,
          editable: !this.readonly,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              allowCreate: this.pm._allowEditingVessel,
              clearable: true,
              selectType: TYPE_NAMES.static_data_Vessel,
              tagValue: 'englishName',
              tagName: 'englishName',
              staticOptions: this.pm.vesselList || [],
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoyageNo'), field: 'voyage', width: 150,
          editable: !this.readonly,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              allowCreate: this.pm.editVoyageMode === 1,
              clearable: true,
              selectType: TYPE_NAMES.static_data_Vessel,
              tagValue: 'voyageNo',
              tagName: 'voyageNo',
              staticOptions: this.legVoyageDataList(params.data.vessel) || [],
              filterable: true
            }
          })
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CarrierCode'),
          field: 'ediCode',
          width: 200,
          editable: !this.readonly,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: 'ETD',
          field: 'etd',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: !this.readonly,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          }
        },
        {
          headerName: 'ETA',
          field: 'eta',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: !this.readonly,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'eta',
          noExport: true,
          width: 200,
          cellRenderer: params => {
            const onExecution = this.documentManage.getPath('onExecution')
            if (this.readonly) {
              return `<div onclick="${onExecution}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;">${this.$t('CargoMsg.Cargo_ScheduleSelection')}</div>`
            }
            return `<div onclick="${onExecution}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_ScheduleSelection')}</div>`
          }
        }
      ]
    },
    importDifferenceField() {
      if (this.form) {
        return this.form.differenceBookingFields || {}
      }
      return {}
    }
  },
  watch: {
    showEntrustmentState(newVal) {
      if (newVal) {
        this.pm.entrustmentStateShowHandler()
      }
    },
    'form.bookingTerm': {
      handler: function(newVal) {
        if (this.pm.editVesselVoyageMode === 2) {
          this.pm.editInputVesselModel()
        }
      }
    },
    'form.shipperLock': {
      handler: function(newVal) {
        this.pm.refreshShipperLock()
      }
    },
    'form.signMBL': {
      handler: function(newVal) {
        if (this.isEditExcludeExportToImport) {
          this.pm.refreshShipperLock()
        }
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onExecution', function(value) {
      context.onExecution(value)
    })
  },
  async created() {
    this.context.loading = true
    const loading = getLoading4Cxt(this)
    try {
    // await this.context.prepareData()
      this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
      this.bookingEDIApiOpen = Number(this.config.get('BookingEDIApiOpen')) !== 0
      this.seAllowReceiptImport = Number(this.config.get('SEAllowReceiptImport')) === 1
      this.isInputMbl = Number(this.config.get('EditMblNoMode'))
      this.showJudgmentOfVoyageNo = Number(this.config.get('JudgmentOfVoyageNo')) === 1
      this.combinedManifest = Number(this.config.get('CombinedManifest')) === 1
      this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
      this.enableShipperConsignNotify = Number(this.config.get('SEBookingEnableShipperConsignNotify')) === 1
      this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
      this.isXycw = String(this.config.get('ToExoSystem')) === 'XYCW'
      this.vesslPlanUpdate = Number(this.config.get('VesslPlanUpdate')) === 1
      await this.pm.init()
    } catch (error) {
      this.$store.dispatch('log/addLog', { type: 'error', error, url: window.location.href })
    } finally {
      this.visible = true
      loading.close()
      this.context.loading = false
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      await cache.load(cacheName.CONFIG)
      this.isHZ = String(cache.config.get('ToExoSystem')) === 'HZ'
      this.isTP = String(cache.config.get('ToExoSystem')) === 'TP'
      this.sCNumberSelectMethod = Number(cache.config.get('SCNumberSelectMethod'))
      this.editPermissions = !Number(cache.config.get('SEABookingAlloweToEdit')) && !this.$checkPermission(['role_SeaEdit_Orange'])
      // 重新设置 isInputMbl，确保刷新后输入框显示正确
      this.isInputMbl = Number(cache.config.get('EditMblNoMode'))
      console.log('onShow - isInputMbl:', this.isInputMbl)
      this.oldVessel = row.vessel || ''
      this.oldVoyageFlight = row.voyageFlight || ''
      // BUG-0012：记录加载时的 MBL，用于保存时检测“真换单”（非空→非空且不同）并弹窗确认是否清空箱货明细
      this.oldMbl = (row.mbl || '').trim().toUpperCase()
      if (isRefresh) {
        this.form = row
        this.fillModelFromCopy()
        this.pm.editingChanged()
        await this.pm.changeJob()
        await this.pm.fillView()
        this.setShippingContractList()
        if (!this.form.masterFlag) {
          this.bookingEdi1Disabled = this.form.containerLoadType === 'LCL'
        } else {
          this.bookingEdi1Disabled = false
        }
        await this.loadEdiReceipt()
        if (this.form.uuid) {
          this.canSubscribeReceipt = await canSubscribeReceipt({ jobUuid: this.form.uuid }).then(res => res.data)
        }
        this.leg.delMultiLegVoyageManagement = []
        this.leg.rowData = []
        if (this.isTP && this.form.uuid) {
          await new MultiLegVoyageManagement(this.form).getMultiLegVoyageManagement()
          this.leg.rowData = this.form.multiLegVoyageManagement || []
        }
      } else {
        if (this.isEditExcludeExportToImport) {
          this.pm.currentVessel = this.pm.vesselList.filter(p => p.englishName === this.form.vessel)[0]
          await this.pm.getVoyageByVessel()
        }
        this.pm.editingChanged()
        await this.loadEdiReceipt()
      }
      this.checkSpecialCharacter()
      if (this.isTP && !this.form.scNoType) {
        this.form.scNoType = SeaExportConstants.TYPE_RFA.code
      }
      if (this.isEditExcludeExportToImport) {
        await this.queryShippingSchedule()
      } else {
        if (row.jobUuid) {
          this.getVesselChangeStatusFunc(row)
        }
      }
      this.shippingCompanySpecificCodeList = [
        { shippingCompanySpecificCode: this.$t('SeaExport.textiles') },
        { shippingCompanySpecificCode: this.$t('SeaExport.nonTextiles') }]
      // 获取该委托单位对应的约号信息
      const customerUuid = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', row.customerId, 'uuid')
      console.log('customerUuid: ' + customerUuid)
      await this.pm.getContractNoList(customerUuid, 'FCL')
      if (row.customerId) {
        await getCNptFunc(row.customerId).then(res => {
          this.cNptList = res.data
        })
      }
      // 获取当前业务的船期信息
      if (this.viewSource) {
        await this.pm.loadShippingSchedules()
      }
      this.form.vesselAndVoyage = this.form.vessel + ' ' + this.form.voyageFlight
    },
    setShippingContractList() {
      JobUtils.queryContractNumber().then(contractNumbers => {
        this.shippingContractList = contractNumbers
      })
    },
    // 获取当前船期是否改配
    async getVesselChangeStatusFunc(row) {
      this.jobUuid = row.jobUuid
      const data = {
        jobUuid: row.jobUuid
      }
      const res = await getVesselChangeStatus(data)
      if (res.ok) {
        console.info('getVesselChangeStatus row.jobUuid', row.jobUuid)
        console.info('getVesselChangeStatus form.jobUuid', this.form.jobUuid)
        // uuid不一致则不处理
        if (row.jobUuid === this.form.jobUuid && res.data) {
          const jobData = new SeaExportJob(this.form)
          if (res.data.status && ((jobData.vessel && jobData.vessel.trim().toUpperCase() !== res.data.vessel) || (jobData.voyageFlight && jobData.voyageFlight.trim().toUpperCase() !== res.data.voyageFlight))) {
            const userId = this.$store.getters.userId
            const ignoreVesselVoyage = LocalStorageUtilsNew.getConfiguration('ignoreVesselVoyage' +
              '_' + userId +
              '_' + res.data.vessel + '_' +
              res.data.voyageFlight + '_' + this.jobUuid)
            if (ignoreVesselVoyage) {
              return
            }
            if (this.isZh) {
              this.jobDataVessel = jobData.vessel
              this.jobDataVoyageFlight = jobData.voyageFlight
            } else {
              this.text = this.$t('SeaExport.vesselText').replace('${3}', res.data.vessel ? res.data.vessel : this.$t('SeaExport.empty')).replace('${4}', res.data.voyageFlight ? res.data.voyageFlight : this.$t('SeaExport.empty')).replace('${1}', jobData.vessel ? jobData.vessel : this.$t('SeaExport.empty')).replace('${2}', jobData.voyageFlight ? jobData.voyageFlight : this.$t('SeaExport.empty'))
            }
            this.shippingDate.vessel = res.data.vessel
            this.shippingDate.voyageFlight = res.data.voyageFlight
            this.vesseldialog = true
          }
        }
      }
    },
    // 船期改配弹窗操作 写入清空 or 写入不清空 or 忽略
    async changeVessel(type) {
      const data = {
        jobUuid: this.jobUuid,
        status: ''
      }
      if (type === 'empty') {
        data.status = 2
      }
      if (type === 'notEmpty') {
        data.status = 3
      }
      if (type === 'ignore') {
        const userId = this.$store.getters.userId
        LocalStorageUtilsNew.setConfiguration('ignoreVesselVoyage' +
          '_' + userId +
          '_' + this.shippingDate.vessel + '_' +
          this.shippingDate.voyageFlight + '_' + this.jobUuid, 1)
        this.vesseldialog = false
        return
      }
      const res = await changeVesselChangeStatus(data)
      if (res.ok) {
        const jobData = new SeaExportJob(this.form)
        if (type !== 'ignore') {
          jobData.vessel = this.shippingDate.vessel
          jobData.voyageFlight = this.shippingDate.voyageFlight
        }
        if (type === 'empty') {
          jobData.portDistrict = ''
          jobData.terminalOpendate = ''
          jobData.terminalCutoff = ''
          jobData.berthPlanDate = ''
          jobData.unBerthPlanDate = ''
          jobData.actualBerthPlanDate = ''
          jobData.actualUnBerthPlanDate = ''
          jobData.atd = ''
        }
        this.vesseldialog = false
      }
    },
    actualArrivalTimeChangeHandler(value) {
      this.form.actualArrivalTime = value
      if (this.form.needSynchronizationAta) {
        this.form.ata = this.form.actualArrivalTime
      }
    },
    actualUnBerthPlanDateChangeHandler(value) {
      this.form.actualUnBerthPlanDate = value
      if (this.form.needSynchronizationAtd) {
        this.form.atd = this.form.actualUnBerthPlanDate
      }
    },
    async getSubmitData() {
      await this.validateForm()
      // 判断 手工输入非 选择
      if (this.form.cNptNo) {
        const cNpt = this.cNptList.find(item => item.no === this.form.cNptNo && item.companyName === this.form.cNptName)
        if (!cNpt) { // new cNpt
          this.newCNpt()
        }
      }

      // CARGO-23318 订舱页签的 主单号栏位 和SONO.栏位 保存数据时自动去除空格
      if (this.form.mbl) {
        this.form.mbl = this.form.mbl.trim()
      }
      if (this.form.soNo) {
        this.form.soNo = this.form.soNo.trim()
      }
      if (this.isInputMbl === 2 || this.isInputMbl === 3) {
        this.form.mblManager = this.mblManager
      }
      JobUtils.checkSpecialCharacters(this.form, 'scNo')
      JobUtils.checkSpecialCharacters(this.form, 'cNptNo')
      JobUtils.checkSpecialCharacters(this.form, 'cNptName')
      const job = { ...this.form }
      // BUG-0012：保存时检测 MBL 真换单（旧非空→新非空且不同）并弹窗确认；确认结果直接随本次
      // 保存 body 顶层提交（不依赖跨事件组件状态——切页签会重跑 onShow 把状态清掉），
      // 后端 clearSubscriptionTraces 清理后按新 MBL 重拉
      let clearPoItemsOnMblChange = false
      const newMbl = (job.mbl || '').trim().toUpperCase()
      if (this.oldMbl && newMbl && this.oldMbl !== newMbl) {
        try {
          await this.$confirm(
            'MBL 已变更，是否清空箱货明细和箱号？清空后系统将按新 MBL 重新拉取数据',
            this.$t('CargoMsg.Cargo_Tips'),
            {
              type: 'warning',
              confirmButtonText: this.$t('SeaExport.Yes'),
              cancelButtonText: this.$t('SeaExport.No'),
              closeOnClickModal: false
            }
          )
          clearPoItemsOnMblChange = true
        } catch (e) {
          clearPoItemsOnMblChange = false
        }
      }
      // Ensure station code is explicitly included in submit payload
      job.stationCode = this.form.stationCode
      console.log(job)
      // 清空子表数据
      // for (const key in job) {
      //   if (typeof job[key] === 'object') {
      //     job[key] = undefined
      //   }
      // }
      if (this.isTP) {
        for (const legData of this.leg.rowData) {
          if (legData.uuid && legData.uuid.includes(this.leg.addKey)) {
            legData.uuid = ''
          }
        }
        return {
          job,
          clearPoItemsOnMblChange,
          multiLegVoyageManagement: this.leg.rowData || [],
          delMultiLegVoyageManagement: this.leg.delMultiLegVoyageManagement || [],
          seaCargoDoc: [this.mblCargoDoc]
        }
      }
      return {
        job,
        clearPoItemsOnMblChange,
        seaCargoDoc: [this.mblCargoDoc]
      }
    },
    newCNpt() {
      const cNpt = {
        no: this.form.cNptNo,
        companyName: this.form.cNptName,
        cmpIdx: this.form.customerId
      }
      addCNpt(cNpt)
    },
    validateForm() {
      const form = this.form
      // 截关日期不能大于开航日期
      if (form.customCutoff && form.etd) {
        const etd = new Date(form.etd)
        const customCutoff = new Date(form.customCutoff)
        const diff = DateUtils.getBetweenDays(customCutoff, etd)
        if (diff < 0) {
          throw new TabError(this.$t('Message.CyCutoffDateCannotBeLaterThanDepartureDate'), 'tabVesselEq')
        }
      }
      // 驳船截关日期不能大于截关日期
      if (form.bargeCustomCutoff && form.customCutoff) {
        const customCutoff = new Date(form.customCutoff)
        const bargeCustomCutoff = new Date(form.bargeCustomCutoff)
        const diff = 365 * (customCutoff.getFullYear() - bargeCustomCutoff.getFullYear()) + 31 * (customCutoff.getMonth() - bargeCustomCutoff.getMonth()) +
          (customCutoff.getDate() - bargeCustomCutoff.getDate())
        if (diff < 0) {
          throw new TabError(this.$t('Message.BargeCutoffDateCannotBeLaterThanCyCutoffDate'), 'tabVesselEq')
        }
      }
      if (this.isTP) {
        for (const data of this.leg.rowData) {
          if (!data.pol) {
            throw new TabError(this.$t('CargoMsg.Cargo_VoyageInfoCannotBeEmpty', [this.$t('SeaExport.LoadingPort')]), 'tabVesselEq')
          }
          if (!data.pod) {
            throw new TabError(this.$t('CargoMsg.Cargo_VoyageInfoCannotBeEmpty', [this.$t('SeaExport.dischargingPort')]), 'tabVesselEq')
          }
          if (!data.vessel) {
            throw new TabError(this.$t('CargoMsg.Cargo_VoyageInfoCannotBeEmpty', [this.$t('CargoMsg.Cargo_ChineseFirstVesselName')]), 'tabVesselEq')
          }
          if (!data.voyage) {
            throw new TabError(this.$t('CargoMsg.Cargo_VoyageInfoCannotBeEmpty', [this.$t('CargoMsg.Cargo_VoyageNo')]), 'tabVesselEq')
          }
          if (!data.etd) {
            throw new TabError(this.$t('CargoMsg.Cargo_VoyageInfoCannotBeEmpty', ['ETD']), 'tabVesselEq')
          }
        }
      }
    },
    // fill View To Copy
    fillViewToCopy() {
      // if (null == job) return;
      // if (null == _jobCopy) _jobCopy = new SeaExportJob();
      // _jobCopy.vessel = job.vessel;
      // _jobCopy.vesselIMO = job.vesselIMO;
      // _jobCopy.voyageFlight = job.voyageFlight;
      // _jobCopy.soNo = job.soNo;
      // _jobCopy.mbl = job.mbl;
      // _jobCopy.mblNo5 = job.mblNo5;
      // _jobCopy.bookingNo = job.bookingNo;
      // _jobCopy.scNo = job.scNo;
      // _jobCopy.vesselCode = job.vesselCode;
    },
    // fill Model From Copy
    fillModelFromCopy() {
      // if (job == null || _jobCopy == null) return
      // if (StrUtils.isEmpty(job.vessel) && !StrUtils.isEmpty(_jobCopy.vessel)) { job.vessel = _jobCopy.vessel }
      // if (StringUtil.trim(job.voyageFlight) != StringUtil.trim(_jobCopy.voyageFlight)) // V.
      // { job.voyageFlight = _jobCopy.voyageFlight }
      // if (StrUtils.isEmpty(job.soNo) && !StrUtils.isEmpty(_jobCopy.soNo)) { job.soNo = _jobCopy.soNo }
      // if (StrUtils.isEmpty(job.mbl) && !StrUtils.isEmpty(_jobCopy.mbl)) { job.mbl = _jobCopy.mbl }
      // if (StrUtils.isEmpty(job.mblNo5) && !StrUtils.isEmpty(_jobCopy.mblNo5)) { job.mblNo5 = _jobCopy.mblNo5 }
      // if (StrUtils.isEmpty(job.bookingNo) && !StrUtils.isEmpty(_jobCopy.bookingNo)) { job.bookingNo = _jobCopy.bookingNo }
      // if (StrUtils.isEmpty(job.scNo) && !StrUtils.isEmpty(_jobCopy.scNo)) { job.scNo = _jobCopy.scNo }
      // if (StrUtils.isEmpty(job.vesselCode) && !StrUtils.isEmpty(_jobCopy.vesselCode)) { job.vesselCode = _jobCopy.vesselCode }
      // if (StrUtils.isEmpty(job.vesselIMO) && !StrUtils.isEmpty(_jobCopy.vesselIMO)) { job.vesselIMO = _jobCopy.vesselIMO }
      // // 重置
      // _jobCopy = null
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    showTransAdvanceTextDialog(title, value, successCallback) {
      this.transAdvanceTextDialog.title = title
      this.transAdvanceTextDialog.value = value
      this.transAdvanceTextDialog.successCallback = successCallback
      this.transAdvanceTextDialog.visible = true
    },
    finishTransAdvanceText() {
      const successCallback = this.transAdvanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.transAdvanceTextDialog.value)
      }
      this.transAdvanceTextDialog.visible = false
    },
    // 订舱操作处理器
    bookingHandler() {
      const self = this
      this.common().getSelectedJobs()
      let exportJob = null
      // 选择事件 - booking.origin.API
      const sinOTransApi = async() => {
        const params = {
          jobUuid: self.globalVar.selectedJob.uuid,
          editStatus: '1'
        }
        ediApi.getSinOTransApi(params).then(result => {
          self.commonCallback().onApiSuccess(result)
        })
      }
      // 选择事件 - booking.origin.FTP
      const btnBookingEdiNewClickHandler = async() => {
        await self.common().selectedJobItemCheck()
        if (self.common().checkConfig('creditOpen', '1')) {
          const accountKey = self.globalVar.selectedJob.customerId
          checkCreditInfo({ [accountKey]: accountKey, jobUuid: self.globalVar.selectedJob.uuid }).then(resp => {
            let canEdit = true
            const creditInfo = resp.data !== null ? resp.data[0] : null
            if (creditInfo) {
              let tip = ''
              if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                const config = {}
                const creditBlock = this.config.get('creditBlockEDI').split(',')
                creditBlock.forEach(c => {
                  config[c.split('-')[0]] = c.split('-')[1] === '1'
                })
                if (config.booking) {
                  const isEffective = JobUtils.isEffective(self.globalVar.selectedJob)
                  if (!isEffective) {
                    if (creditInfo.amountExceeded) {
                      tip += this.$t('CargoMsg.Cargo_Limit')
                    }
                    if (creditInfo.dateExceeded) {
                      tip += this.$t('CargoMsg.Cargo_AccountPeriod')
                    }
                    canEdit = false
                    self.$message.info(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                  }
                }
              }
            }
            if (canEdit) {
              self.globalVar.title = this.$t('SeaExport.BookingEDI')
              self.globalVar.ediType = 1
              self.globalVar.shutOutIdentification = 0
              self.globalVar.editStatus = 9
              if (self.common().checkConfig('useEDITemplate', '1')) {
                self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
              } else {
                getBookingEDI(self.globalVar.selectedJobKeys)
              }
            }
          })
        } else {
          self.globalVar.title = this.$t('SeaExport.BookingEDI')
          self.globalVar.ediType = 1
          self.globalVar.shutOutIdentification = 0
          self.globalVar.editStatus = 9
          if (self.common().checkConfig('useEDITemplate', '1')) {
            self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
          } else {
            getBookingEDI(self.globalVar.selectedJobKeys)
          }
        }
      }
      // 选择事件 - booking.correct.API
      const sinOTransUpdateApi = async() => {
        await self.common().selectedJobItemCheck()
        const params = {
          jobUuid: self.globalVar.selectedJob.uuid,
          editStatus: '2'
        }
        ediApi.getSinOTransApi(params).then(result => {
          self.commonCallback().onApiSuccess(result)
        })
      }
      // 选择事件 - booking.correct.FTP
      const btnBookingEdiEditClickHandler = async() => {
        await self.common().selectedJobItemCheck()
        if (self.common().checkConfig('creditOpen', '1')) {
          const accountKey = self.globalVar.selectedJob.customerId
          checkCreditInfo({ [accountKey]: accountKey, jobUuid: self.globalVar.selectedJob.uuid }).then(resp => {
            let canEdit = true
            const creditInfo = resp.data !== null ? resp.data[0] : null
            if (creditInfo) {
              let tip = ''
              if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                const config = {}
                const creditBlock = this.config.get('creditBlockEDI').split(',')
                creditBlock.forEach(c => {
                  config[c.split('-')[0]] = c.split('-')[1] === '1'
                })
                if (config.booking) {
                  const isEffective = JobUtils.isEffective(self.globalVar.selectedJob)
                  if (!isEffective) {
                    if (creditInfo.amountExceeded) {
                      tip += this.$t('CargoMsg.Cargo_Limit')
                    }
                    if (creditInfo.dateExceeded) {
                      tip += this.$t('CargoMsg.Cargo_AccountPeriod')
                    }
                    canEdit = false
                    self.$message.info(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                  }
                }
              }
            }
            if (canEdit) {
              self.globalVar.title = this.$t('SeaExport.BookingCorrection')
              self.globalVar.ediType = 1
              self.globalVar.shutOutIdentification = 0
              self.globalVar.editStatus = 4
              if (self.common().checkConfig('useEDITemplate', '1')) {
                self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
              } else {
                getBookingEDI(self.globalVar.selectedJobKeys)
              }
            }
          })
        } else {
          self.globalVar.title = this.$t('SeaExport.BookingCorrection')
          self.globalVar.ediType = 1
          self.globalVar.shutOutIdentification = 0
          self.globalVar.editStatus = 4
          if (self.common().checkConfig('useEDITemplate', '1')) {
            self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
          } else {
            getBookingEDI([self.globalVar.selectedJob.uuid])
          }
        }
      }
      // 选择事件 - booking.shutOut.EDI
      const btnBookingShutOutClickHandler = async() => {
        await self.common().selectedJobItemCheck()
        if (self.common().checkConfig('creditOpen', '1')) {
          const accountKey = self.globalVar.selectedJob.customerId
          checkCreditInfo({ [accountKey]: accountKey, jobUuid: self.globalVar.selectedJob.uuid }).then(resp => {
            let canEdit = true
            const creditInfo = resp.data !== null ? resp.data[0] : null
            if (creditInfo) {
              let tip = ''
              if (creditInfo.amountExceeded || creditInfo.dateExceeded) {
                const config = {}
                const creditBlock = this.config.get('creditBlockEDI').split(',')
                creditBlock.forEach(c => {
                  config[c.split('-')[0]] = c.split('-')[1] === '1'
                })
                if (config.booking) {
                  const isEffective = JobUtils.isEffective(self.globalVar.selectedJob)
                  if (!isEffective) {
                    if (creditInfo.amountExceeded) {
                      tip += this.$t('CargoMsg.Cargo_Limit')
                    }
                    if (creditInfo.dateExceeded) {
                      tip += this.$t('CargoMsg.Cargo_AccountPeriod')
                    }
                    canEdit = false
                    self.$message.info(this.$t('SeaExport.CreditControlTheClient') + tip + this.$t('SeaExport.HasExceededCannotEDI'))
                  }
                }
              }
            }
            if (canEdit) {
              self.globalVar.title = this.$t('SeaExport.BookingShutOut')
              self.globalVar.ediType = 1
              self.globalVar.shutOutIdentification = 1
              self.globalVar.editStatus = 4
              if (self.common().checkConfig('useEDITemplate', '1')) {
                self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
              } else {
                getBookingEDI([self.globalVar.selectedJob.uuid])
              }
            }
          })
        } else {
          self.globalVar.title = this.$t('SeaExport.BookingShutOut')
          self.globalVar.ediType = 1
          self.globalVar.shutOutIdentification = 1
          self.globalVar.editStatus = 4
          if (self.common().checkConfig('useEDITemplate', '1')) {
            self.common().showEDITemplateWin(self.globalVar.selectedJobKeys)
          } else {
            getBookingEDI([self.globalVar.selectedJob.uuid])
          }
        }
      }
      // 订舱回执导入 选择事件 - booking.import
      const btnBookingEdiReceiptClickHandler = async() => {
        await self.common().selectedJobItemCheck()
        self.$refs['importFile'].click()
      }

      // >>>====== 内部和涉及各类弹窗回调方法 <<<=====
      // 获取订舱EDI
      const getBookingEDI = (selectedKeys) => {
        const params = {
          jobUuids: selectedKeys,
          editStatus: self.globalVar.editStatus
        }
        self.loading = getLoading()
        ediApi.getBookingEDI(params).then(result => { self.commonCallback().onExportEDISuccess(result) })
          .catch(message => { self.commonCallback().onExportEDIFail(message) })
          .finally(() => { self.loading.close() })
      }
      // 订舱-回执导入请求成功回调方法
      const onImportSucceeded = (response) => {
        exportJob = response.data
        const job = self.globalVar.selectedJob
        if (self.common().needLoadCargoDoc(job)) {
          self.loading = getLoading()
          const params = { jobUuid: job.uuid }
          jobApi.getCargoDoc(params).then(result => {
            job.cargoDoc = result.data
            loadCargoDocHandler()
          }).finally(() => { self.loading.close() })
        } else {
          loadCargoDocHandler()
        }
      }
      // 加载CargoDoc请求成功回调方法
      const loadCargoDocHandler = async() => {
        const job = self.globalVar.selectedJob
        if (exportJob == null) {
          self.$message.info('回执单导入失败!')
          return
        }
        if (exportJob.mbl !== job.mbl) {
          await this.$confirm(this.$t('SeaExport.PrimaryOrderNotSameReceipt'), this.$t('SeaExport.Confirm'), { type: 'info' })
          updateSeaJobsFromReceipt()
        } else {
          updateSeaJobsFromReceipt()
        }
      }
      // 从接收返回的exportJob更新seaJob
      const updateSeaJobsFromReceipt = () => {
        const job = self.globalVar.selectedJob
        const docs = job.cargoDoc
        const bool = docs.find(doc => doc.docType === MBL && doc.cfmState === 0)
        if (!bool) {
          self.$message.warning('该票MBL对单状态不是未开始，无法导入。')
          return
        }
        self.loading = getLoading()
        exportJob.oldJobUuid = job.uuid
        jobApi.updateSeaJobsFromReceipt(exportJob).then(response => onReceiptupdateSucceeded(response))
          .finally(() => { self.loading.close() })
      }
      // 从接收返回的exportJob更新seaJob - 请求成功回调方法
      const onReceiptupdateSucceeded = (response) => {
        self.loading = getLoading()
        const data = {
          jobUuid: self.globalVar.selectedJobKey,
          filedCode: '_edi_receipt_import'
        }
        trackingApi.updateTrackingByEvent(data).then(response => {
          self.$message.success(this.$t('SeaExport.ReceiptImportedSuccessfully'))
        }).finally(() => { self.loading.close() })
      }
      return { sinOTransApi, btnBookingEdiNewClickHandler, sinOTransUpdateApi, btnBookingEdiEditClickHandler,
        btnBookingEdiReceiptClickHandler, btnBookingShutOutClickHandler, onImportSucceeded }
    },
    // >>> === 公用方法及特殊回调方法
    // EDI公共方法
    common() {
      const self = this
      // config检测方法
      const checkConfig = (prop, targetValue) => {
        return self.config !== null && self.config.get(prop) === targetValue
      }
      // 获取selectedJobs & 拼接各类所需对象
      const getSelectedJobs = () => {
        const selectedJob = self.form
        if (!selectedJob) {
          return
        }
        self.globalVar.selectedJob = selectedJob
        self.globalVar.selectedJobKey = selectedJob.uuid
        self.globalVar.selectedJobs = [selectedJob]
        self.globalVar.selectedJobKeys = [selectedJob.uuid]
      }
      // 显示EDI模板选择弹窗(selectorDialog)
      const showEDITemplateWin = (uuids, item = null) => {
        if (uuids) {
          self.globalVar.ediTemplateWin.uuids = uuids
        } else {
          self.globalVar.ediTemplateWin.item = item
        }
        self.loading = getLoading()
        getEDITemplate({ templateType: this.globalVar.ediType, shutOutIdentification: this.globalVar.shutOutIdentification }).then(result => {
          self.selectorDialog.title = self.globalVar.title
          self.selectorDialog.rowData = result.data
          if (self.globalVar.sendRPA && self.selectorDialog.rowData) {
            self.selectorDialog.rowData = self.selectorDialog.rowData.filter(p => p.sendType === 'YD')
          }
          self.selectorDialog.visible = true
        }).finally(() => {
          self.loading.close()
        })
      }
      // 弹出messagePreviewDialog
      const setEdiTabWindow = () => {
        self.messagePreviewDialog.params = {
          job: self.globalVar.selectedJob,
          title: self.globalVar.title,
          ediType: self.globalVar.ediType,
          // ediFileName: self.globalVar,
          ediCollection: self.globalVar.ediDatas,
          sendVersion: self.globalVar.sendVersion,
          ediStatus: self.globalVar.editStatus,
          ediTemplate: self.globalVar.ediTemplate,
          ediStatusName: self.globalVar.ediStatusName,
          sendRPA: self.globalVar.sendRPA
        }

        self.messagePreviewDialog.visible = true
      }
      // 判断SeaExportJob是否需要加载CargoDoc
      const needLoadCargoDoc = (job) => {
        return job.uuid && (job.cargoDoc == null || job.cargoDoc.length < 1)
      }
      // 判断SeaExportJob是否需要加载Containers
      const needLoadContainers = (job) => {
        return job.uuid && (job.containers == null || job.containers.length < 1)
      }
      // 判断数据选择情况
      const selectedJobItemCheck = () => {
        if (!self.globalVar.selectedJobKey) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return Promise.reject()
        }
      }

      return { checkConfig, getSelectedJobs, showEDITemplateWin, setEdiTabWindow, needLoadCargoDoc, needLoadContainers,
        selectedJobItemCheck }
    },
    // EDI公共回调方法
    commonCallback() {
      const self = this
      // edi导出成功回调方法
      const onExportEDISuccess = (response) => {
        if (!response || !response.data || JSON.stringify(response.data) === '{}') {
          self.$message.info(this.$t('SeaExport.NoImportEDI'))
          return
        }
        const result = response.data
        const sendVersion = JSON.parse(result.sendVersion)
        self.globalVar.sendVersion = sendVersion[self.globalVar.selectedJob.uuid]
        delete result.sendVersion
        self.globalVar.ediDatas = result
        self.common().setEdiTabWindow()
      }
      // edi导出失败回调方法
      const onExportEDIFail = (dataMsg) => {
        if (dataMsg instanceof Error) {
          return
        }
        const modelMap = ModelMap['ProperyLabelMap']
        const errorMsgArr = dataMsg ? dataMsg.split(';') : null
        let finalMessage = ''
        const suffixMsg = this.$t('SeaExport.ItIsEmpty') + '<br/>'
        if (errorMsgArr && errorMsgArr.length > 0) {
          errorMsgArr.forEach(errorMsg => {
            const modelField = errorMsg.split('.')
            if (modelField && modelField.length > 0) {
              const model = modelMap[modelField[0]]
              if (model) {
                finalMessage += (model[modelField[1]] + suffixMsg)
              }
            } else {
              finalMessage += errorMsg
            }
          })
        }
        if (finalMessage) {
          self.$message.error({ dangerouslyUseHTMLString: true, message: finalMessage })
        } else {
          self.$message.error({ dangerouslyUseHTMLString: true, message: dataMsg })
        }
      }
      // 订舱-更正-api请求成功回调方法 引用到了
      const onApiSuccess = (response) => {
        if (!response || !response.data) {
          self.$message.warning('响应数据为空')
          return
        }
        const result = response.data
        if (result.isSuccess) {
          self.$message.success(this.$t('SeaExport.RequestSuccessful'))
        } else {
          let text = result.text
          text = text.substring(0, text.length - 5) +
            text.substring(text.length - 5, text.length).replace(';', '')
          self.errorLogDialog.errorLog = text
          self.errorLogDialog.visible = true
        }
      }

      return { onExportEDISuccess, onExportEDIFail, onApiSuccess }
    },
    // 回执导入-系统文件选择change触发事件
    onImportFile(event) {
      const fileInput = this.$refs['importFile']
      const file = fileInput.files[0]
      if (file.size === 0) {
        this.$message.warning(this.$t('SeaExport.FileContentIsEmpty'))
      }
      if ((Math.round(file.size * 100 / (1024 * 1024)) / 100) > 2) {
        this.$message.warning(this.$t('SeaExport.FileSizeCannotLargerThan2MB'))
        return
      }
      savePmsFile(file).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.bookingHandler().onImportSucceeded(response)
        }
      })
      fileInput.value = ''
    },
    // EDI模板选择弹窗(dialog-selector)选择数据后回调函数
    getEDICallback(row) {
      // 太平引导页面
      if (row && row.bootHelperPage === 1) {
        this.globalVar.ediTemplate = row
        this.ediBaseWindow.callBackFunc = this.doEDICallback
        this.ediBaseWindow.visible = true
        this.$nextTick(() => {
          this.$refs.ediBaseWindow.showDetail(this.form)
        })
      } else {
        this.doEDICallback(row)
      }
    },
    ediChangeHandler() {
      this.$emit('ediChangeHandler')
    },
    doEDICallback(row) {
      this.globalVar.ediTemplate = row
      this.globalVar.popMultiSegNumRulesType = 1
      if (this.common().checkConfig('EDINoRuleConfigMode', '1') && this.globalVar.ediType === 5) {
        this.multiSegNumRulesDialog.visible = true
      } else {
        this.multiSegNumRulesCallback(null)
      }
    },
    // 多段号码规则配置弹窗(multi-seg-num-rule-dialog)回调函数入口
    multiSegNumRulesCallback(ruleEDINos) {
      switch (this.globalVar.popMultiSegNumRulesType) {
        case 1: this.multiSegNumRulesCallbackHandler().callbackHandle1(ruleEDINos)
          break
        case 2: this.multiSegNumRulesCallbackHandler().callbackHandle2(ruleEDINos)
          break
      }
    },
    // 多段号码规则配置弹窗(multi-seg-num-rule-dialog)回调函数实际处理方法
    multiSegNumRulesCallbackHandler() {
      const self = this
      // 回调处理方法1, 订舱菜单触发多段号码规则弹窗回调函数
      const callbackHandle1 = (ruleEDINos) => {
        let ruleEDINoArr = []
        if (ruleEDINos && self.common().checkConfig('EDINoRuleConfigMode', '1') && self.globalVar.ediType === 5) {
          ruleEDINoArr = ruleEDINos
        }
        if (self.globalVar.ediTemplateWin.item) {
          self.globalVar.ediTemplateWin.item.ruleEDINos = ruleEDINoArr
          const param = {}
          param.ediType = self.globalVar.ediType
          param.templateId = self.globalVar.ediTemplate.uuid
          param.item = self.globalVar.ediTemplateWin.item
          param.editStatus = self.globalVar.editStatus
          self.loading = getLoading()
          ediApi.getEDIObject(param).then(result => self.commonCallback().onExportEDISuccess(result))
            .catch(message => self.commonCallback().onExportEDIFail(message))
            .finally(() => { self.loading.close() })
        } else {
          const param = {}
          param.ediType = self.globalVar.ediType
          param.templateId = self.globalVar.ediTemplate.uuid
          param.jobUuids = self.globalVar.ediTemplateWin.uuids
          param.editStatus = self.globalVar.editStatus
          param.ruleEDINos = ruleEDINoArr
          this.loading = getLoading()
          ediApi.getEDI(param).then(result => self.commonCallback().onExportEDISuccess(result))
            .catch(message => self.commonCallback().onExportEDIFail(message))
            .finally(() => { self.loading.close() })
        }
      }
      // 回调处理方法2, 舱单菜单触发多段号码规则弹窗回调函数
      const callbackHandle2 = (ruleEDINos) => {
        self.shippingHandler().getShippingEDI(ruleEDINos)
      }
      return { callbackHandle1, callbackHandle2 }
    },
    // CARGO-46703 对EDI的货物明细取值进行校验
    async toBookingPre(index) {
      // 判断是否开启验证规则
      const useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
      // 查询是否存在节点
      const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_BOOKING_EDI_UPLOAD.code, this.$store.getters.currentOfficeId)
      if (useCheckRule && checkNodeFlag) {
        this.checkingWindow.visible = true
        this.checkingWindow.checkNode = CheckRuleConstants.NODE_BOOKING_EDI_UPLOAD.code
        this.checkingWindow.callBack = () => {
          this.toBooking(index)
        }
      } else {
        this.toBooking(index)
      }
    },
    toBooking(index) {
      this.globalVar.sendRPA = false
      switch (index) {
        case '更正':
          this.globalVar.ediStatusName = this.$t('SeaExport.CorrectBooking')
          this.bookingHandler().btnBookingEdiEditClickHandler()
          break
        case 'FTP1':
          this.globalVar.ediStatusName = this.$t('SeaExport.OriginalBooking')
          this.bookingHandler().btnBookingEdiNewClickHandler()
          break
        case 'FTP0':
          this.globalVar.ediStatusName = this.$t('SeaExport.CorrectBooking')
          this.bookingHandler().btnBookingEdiEditClickHandler()
          break
        case 'API0':
          this.globalVar.ediStatusName = this.$t('SeaExport.OriginalBooking')
          this.bookingEDIApi('9')
          // this.bookingHandler().sinOTransApi()
          break
        case 'API1':
          this.bookingEDIApi('5')
          // this.bookingHandler().sinOTransApi()
          break
        case this.$t('SeaExport.ReceiptImport'):
          this.bookingHandler().btnBookingEdiReceiptClickHandler()
          break
        case 'FTP2':
          this.globalVar.ediStatusName = this.$t('SeaExport.BookingShutOut')
          this.bookingHandler().btnBookingShutOutClickHandler()
          break
        case 'API2':
          this.globalVar.ediStatusName = this.$t('SeaExport.BookingShutOut')
          this.bookingEDIApi('1')
          break
        case 'RPA1':
          // 正在订舱
          if (this.form && (this.form.bookingState === JOB_BOOKING_STATE_BOOKING.code || this.form.sendRPASuccess)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CheckCanSendEDI'))
            break
          }
          this.globalVar.sendRPA = true
          this.globalVar.ediStatusName = this.$t('SeaExport.OriginalBooking')
          this.bookingHandler().btnBookingEdiNewClickHandler()
          break
        default:
          this.bookingHandler().btnBookingEdiNewClickHandler()
          break
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.jobuuid = this.form.uuid
      params.JOB_UUID = this.form.uuid
      params.category = 'BACNKLETTER'
      params.ctx = new SeaExportJob(this.form)
      // this.$logger.log('params', params)
      return params
      // TemplateSelectorWin.getInstance().showThisWin(view.job, "BACNKLETTER", params, view);
    },
    generateMblNo() {
      if (this.isInputMbl === 2 || this.isInputMbl === 3) {
        const job = this.form
        if (!job.carrierId || job.carrierId === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CarrierCheck'))
          return
        }
        const data = {}
        data.currentBranchId = this.$store.getters.currentOfficeId
        data.carrierId = job.carrierId
        data.department = this.$store.getters.currentDeptId
        if (this.isInputMbl === 3) {
          // 传 订单渠道 进行 提单匹配
          data.channel = this.form.salesChannel || CHANNEL_0.englishName
        }
        checkReminderFunc(data).then((res) => {
          const obj = res.data
          if (obj.useNum && obj.useNum > 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NumberMarginUse', [obj.useNum]))
          }
          if (obj.companyNum && obj.companyNum > 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NumberMarginCompany', [obj.companyNum]))
          }
          if (obj.mblNo) {
            // 记录当前使用的唯一标识
            this.mblManager = obj.uuid
            this.form.mbl = obj.mblNo
          }
        })
      } else {
        if (this.form.mbl) {
          this.$confirm(this.$t('SeaExport.TheBeVoidedAndThis'), this.$t('Message.Warning'), { type: 'warning', showClose: false }).then(res => {
            this.mblConfig.visible = true
          })
        } else {
          this.mblConfig.visible = true
        }
      }
    },
    allocateSoNo() { // CARGO-15389
      allocateSoNo(this.form.jobUuid).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('success')
      }).finally(() => {
        self.loading.close()
      })
    },
    generateSoNo() {
      this.soNoConfig.visible = true
    },
    // 创建订阅回执
    subscribeReceiptExec() {
      this.loading = getLoading4Cxt(this)
      subscribeReceiptExec({ jobUuid: this.form.uuid }).then(res => {
        this.form.bookingState = res.data.bookingState
        if (this.form.bookingState === SystemConstants.JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS.code) {
          this.canSubscribeReceipt = false
          this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_BookingReceiptSubscriptionFailed') + ':' + res.data.errorMsg)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    /**
     * api接口集合 原始  state 9：新增  5：修改  1：删除
     */
    bookingEDIApi(state) {
      if (this.isHZ) {
        if (this.form.containerLoadType !== ContainerLoadType.FCL_CARGO_TYPE.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlySupportedFCL'))
          return
        }
        if (this.form.seaEQ && this.form.seaEQ.length > 3) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CannotExceedThree'))
          return
        }
        this.apiPopup.interfaceArray = '4'
      } else {
        this.apiPopup.interfaceArray = this.config.get('BookingEDIApiOpen')
      }
      this.apiPopup.title = this.$t('SeaExport.Booking') + ' API'
      this.apiPopup.state = state
      this.apiPopup.interfaceType = 1
      this.apiPopup.visible = true
    },
    async selectedApiCallback(row) {
      if (row) {
        const inteface = row['id'].toString()
        if (inteface === '1') {
          const params = {
            jobUuid: this.form.uuid,
            editStatus: '1'
          }
          ediApi.getSinOTransApi(params).then(result => this.commonCallback().onApiSuccess(result)).catch(message => {
            this.$message.error(message)
          }).finally(() => {
            this.loading.close()
          })
        } else if (inteface === '2') {
          if (!await this.sendNingBoCheck()) {
            return
          }

          const param = {}
          param.jobUuid = this.form.uuid
          param.editStatus = parseInt(this.apiPopup.state)
          param.sendType = 'IFTMBF'
          this.loading = getLoading()
          if (param.editStatus === 9) {
            // 如果是原始，需要判断版本号
            ediApi.getNextEDIVersion({ jobUuid: param.jobUuid, sendType: 1 }).then(result => {
              if (result.data === 0) {
                this.sendNingBo(param)
              } else {
                const jobNo = this.pm.job.jobNo
                const message = '该job {0} 已成功发送过EDI订舱，<br>此次发送是{1}-{2}，<br>请确认是否需要再次发送？'
                this.$confirm(StrUtils.substitute(message, jobNo, jobNo, result.data), this.$t('common.tips.prompt'), {
                  confirmButtonText: this.$t('common.btn.ok'),
                  cancelButtonText: this.$t('common.btn.cancel'),
                  dangerouslyUseHTMLString: true,
                  type: 'warning'
                }).then(() => {
                  this.sendNingBo(param)
                })
              }
            }).catch(message => {
              this.$message.error(message)
            }).finally(() => {
              this.loading.close()
            })
          } else {
            this.sendNingBo(param)
          }
        } else if (inteface === '3') { // 吉联新
          const param = {}
          param.jobUuids = [this.form.uuid]
          param.editStatus = parseInt(this.apiPopup.state)
          param.sendType = EdiType.BOOKING_EDI_TYPE.code // 订舱
          param.lob = 'SE'
          const loading = getLoading4Cxt()
          ediApi.getJiLianStarAPI(param).then(result => this.apiSuccess(result, true)).catch(message => {
            this.$message.error(message)
          }).finally(() => {
            loading.close()
          })
        } else if (inteface === '4') {
          if (this.apiPopup.state === '9') {
            const loading = getLoading4Cxt()
            const param = { ...this.form }
            try {
              if (this.form.op) {
                const op = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', this.form.op)
                if (op) {
                  param.opName = op.chineseName
                  param.opTel = op.phone
                  param.opEmail = op.email
                }
              }
              if (this.form.customsBroker) {
                const customsBroker = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.form.customsBroker)
                if (customsBroker && customsBroker.chineseName === '重庆民生报关行有限公司') {
                  param.exportManifestMode = '0'
                }
              }
              if (this.form.destinationPortCode) {
                const destinationPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.form.destinationPortCode)
                param.destinationPortName = destinationPort.englishName
              }
              if (this.form.carrierId) {
                const carrier = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.form.carrierId)
                param.carrierCode = carrier.shortName
              }
              param.sendType = EdiType.BOOKING_EDI_TYPE.code // 订舱
              delete param.containerUsages
              delete param.containers
              if (param.seaEQ) {
                for (let i = 1; i <= param.seaEQ.length; ++i) {
                  param['eqSize' + i ] = param.seaEQ[i - 1].eqSize
                  param['eqType' + i ] = param.seaEQ[i - 1].eqType
                  param['containerQuantity' + i ] = param.seaEQ[i - 1].eqQuantity
                }
              }
            } catch (e) {
              loading.close()
              console.log(e)
              return
            }
            ediApi.getMingShenBookingAPI(param).then(result => {
              if (result.data.success) {
                this.$message.success(this.$t('Message.SuccessfullySent'))
              } else {
                this.$message.error(result.data.message)
              }
            }).catch(message => {
              this.$message.error(message)
            }).finally(() => {
              loading.close()
            })
          } else if (this.apiPopup.state === '1') {
            const param = {
              jobUuid: this.form.uuid,
              sendType: EdiType.CANCELLATION_EDI.code, // 取消订舱
              jobNo: this.form.jobNo
            }
            const loading = getLoading4Cxt()
            ediApi.getMingShenBookingAPI(param).then(result => {
              if (result.data.success) {
                this.$message.success(this.$t('Message.SuccessfullySent'))
              } else {
                this.$message.error(result.data.message)
              }
            }).catch(message => {
              this.$message.error(message)
            }).finally(() => {
              loading.close()
            })
          }
        }
      }
    },
    checkSpecialCharacter() {
      if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.form[key])
        }
      } else {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = null
        }
      }
    },
    // 宁波电子口岸发送验证
    async sendNingBoCheck() {
      if (!this.form.dispatchingPlace || !this.form.dispatchingPlace.trim()) {
        this.$message.warning(`${this.$t('SeaExport.BasicTab')}-${this.$t('SeaExport.TheBillOfLadingEmpty')}`)
        return false
      }
      if (!this.form.quantityActual || !this.form.weightActual || !this.form.cubageActual) {
        this.$message.warning(`${this.$t('SeaExport.BasicTab')}-${this.$t('SeaExport.TheHairBodyCannotEmpty')}`)
        return false
      }
      if (!this.form.packing || !this.form.packing.trim()) {
        this.$message.warning(`${this.$t('SeaExport.BasicTab')}-${this.$t('SeaExport.PackageCannotBeEmpty')}`)
        return false
      }
      const mDoc = await new SeaExportJob(this.form).getCargoDocByType('MBL', false)
      if (mDoc) {
        if (!mDoc.shipperLine1 || !mDoc.shipperLine1.trim()) {
          this.$message.warning(`${this.$t('SeaExport.MBLTab')}-${this.$t('SeaExport.ShipperCannotBeBlank')}`)
          return false
        }
        if (!mDoc.consigneeLine1 || !mDoc.consigneeLine1.trim()) {
          this.$message.warning(`${this.$t('SeaExport.MBLTab')}-${this.$t('SeaExport.ConsigneeCannotBeEmpty')}`)
          return false
        }
        if (!mDoc.notifyLine1 || !mDoc.notifyLine1.trim()) {
          this.$message.warning(`${this.$t('SeaExport.MBLTab')}-${this.$t('SeaExport.NotifierCannotBeBlank')}`)
          return false
        }
      }
      return true
    },
    sendNingBo(param) {
      ediApi.getNingBoEportAPI(param).then(result => this.apiSuccess(result)).catch(message => {
        this.$message.error(message)
      }).finally(() => {
        this.loading.close()
      })
    },
    loadBookingLog() {
      this.bookingLogDialog.jobUuid = this.form.uuid
      this.bookingLogDialog.sendType = 'IFTMBF'
      this.bookingLogDialog.visible = true
    },
    onContractNoChange(data) {
      console.log('onContractNoChange: data: ' + data)
      console.log('onContractNoChange: this.form.scNo: ' + this.form.scNo)
      this.form.contractNo = data.contractNo
      if (!this.form.scNo) { this.form.scNo = data.contractNo }
    },
    legData(num) {
      return this.$t('CargoMsg.Cargo_Leg' + num)
    },
    addClickHandler() {
      const rows = this.leg.rowData
      if (rows.length >= 5) {
        return
      }
      const data = new MultiLegVoyageManagement().fillDefaultValue().getData()
      data.leg = rows.length + 1
      data.uuid = this.leg.addKey + getUuid()
      this.leg.rowData.push(data)
    },
    deleteClickHandler() {
      const rows = this.leg.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        return
      }
      const lastData = this.leg.rowData[this.leg.rowData.length - 1]
      if (lastData.uuid !== rows[0].uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeleteFromLastLeg'))
        return
      }
      const list = []
      for (const data of this.leg.rowData) {
        let b = true
        for (const row of rows) {
          if (data.uuid === row.uuid) {
            b = false
            if (!data.uuid.includes(this.leg.addKey) && data.uuid) {
              this.leg.delMultiLegVoyageManagement.push(data.uuid)
            }
          }
        }
        if (b) {
          list.push(data)
        }
      }
      this.leg.rowData = list
    },
    // 船期选择
    onExecution(value) {
      if (this.readonly) {
        return
      }
      const data = this.leg.rowData.find(p => value === p.uuid)
      this.voyageShowDialog = true
      // 船名
      this.voyageShowDialogData.vesselId = data.vessel || ''
      // 航次
      this.voyageShowDialogData.voyageNo = data.voyage || ''
      // etd
      this.voyageShowDialogData.etd = data.etd || ''
      // 装货港
      this.voyageShowDialogData.loadingPortCode = data.pol || ''
      // 卸货港
      this.voyageShowDialogData.dischargingPortCode = data.pod
      // 航程多程管理
      this.voyageShowDialogData.legUuid = data.uuid
      this.$refs.voyageShowDialog.onshow(this.voyageShowDialogData)
    },
    onCellChange(params) {
      const data = params.data
      this.loadVoyage(data.vessel)
      data.voyage = ''
      this.leg.gridApi.refreshCells({ force: true }) // 刷新
    },
    legVoyageDataList(vessel) {
      if (!vessel) {
        return []
      }
      return this.voyageMap.get(vessel) || []
    },
    async loadVoyage(vessel) {
      if (!vessel || this.voyageMap.has(vessel)) return // 已缓存
      const currentVessel = this.pm.vesselList.find(p => p.englishName === vessel)
      if (!currentVessel) {
        this.voyageMap.set(vessel, [])
        return
      }
      const voyages = await Voyage.getVoyage(currentVessel.vesselId)
      const list = Object.values(
        voyages.reduce((acc, cur) => {
          const key = cur.voyageNo
          if (!acc[key] || cur.masterCarrier) acc[key] = cur
          return acc
        }, {})
      )
      this.voyageMap.set(vessel, list)
    },
    /**
     * 成功
     */
    apiSuccess(event, isJlx = false) {
      const o = event.data
      if (o) {
        const success = o.isSuccess
        if (success) {
          if (o.msg) {
            this.errorLogDialog.errorLog = o.msg
            this.errorLogDialog.visible = true
            return
          }
          this.$message.success(this.$t('SeaExport.RequestSuccessful'))
        } else {
          const text = o.text.toString()
          const textStr = isJlx ? text : text.substring(0, text.length - 5) + text.substring(text.length - 5, text.length).replace(';', '')
          this.errorLogDialog.errorLog = textStr
          this.errorLogDialog.visible = true
        }
      }
    },
    // CARGO-17017 船名航次根据基本界面填写的起运港目对比船期带出
    async queryShippingSchedule() {
      if (!this.controlVessel) return
      const filter = {}
      if (this.form.loadingPortCode) filter.loadingPort = this.form.loadingPortCode
      if (this.form.dischargingPortCode) filter.destinationPort = this.form.dischargingPortCode
      if (this.form.carrierId) filter.carrierId = this.form.carrierId
      if (this.form.etd) {
        filter.startDate = this.form.etd
        filter.endDate = this.form.etd
      }
      this.pm.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
      if (filter && Object.keys(filter).length > 0) {
        const shippingList = await queryShippingSchedule(filter).then(res => res.data.list)
        if (shippingList && shippingList.length > 0) {
          this.pm.vesselList = shippingList
          if (shippingList.length === 1) { // 只有一条匹配上的时候需要赋值
            this.form.vessel = shippingList[0].englishName
            this.form.voyageFlight = shippingList[0].voyageNo
          }
          this.pm.currentVessel = this.pm.vesselList.filter(p => p.englishName === this.form.vessel)[0]
          await this.pm.getVoyageByVessel()
        }
      }
      this.$logger.log('this.pm.vesselList===============', this.pm.vesselList)
      if (!this.pm.vesselList || this.pm.vesselList.length <= 0) {
        this.pm.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
      }
      this.pm.editInputVesselModel()
    },
    async loadEdiReceipt() {
      this.ediReceipt.showEdiReceipt = false
      this.ediReceiptCommon.showEdiReceipt = false
      if (this.pm.job.jobNo) {
        await queryEdiReceipts({ jobNo: this.pm.job.jobNo }).then(res => {
          if (res.data && res.data.length > 0) {
            // 降序展示
            this.ediReceiptCommon.data = res.data.filter(p => p.receiptSource === RECEIPT_SOURCE_EMAIL.code || p.receiptSource === RECEIPT_SOURCE_YD.code).sort((a, b) => {
              const timeA = new Date(a.time).getTime()
              const timeB = new Date(b.time).getTime()
              return timeB - timeA
            })
            this.ediReceiptCommon.showEdiReceipt = this.ediReceiptCommon.data.length > 0
            this.ediReceipt.data = res.data.filter(p => !p.receiptSource || p.receiptSource === RECEIPT_SOURCE_HPL.code)
            this.ediReceipt.showEdiReceipt = this.ediReceipt.data.length > 0
          }
        })
      }
    },
    syncBC(data) {
      data['jobUuid'] = this.pm.job.jobUuid
      syncBc(data).then(res => {
        if (res.data) {
          this.$message.success(this.$t('Message.EditedSuccessfully'))
          this.form['vessel'] = data['vessel']
          this.form['voyageFlight'] = data['voyage']
          this.form['vesselIMO'] = data['imoCode']
          // CARGO-28893 【海运订舱】-【订舱回执】调整订舱回执页字段【SO_NO】同步到订舱编号
          this.form['bookingNo'] = data['soNo']
          this.form['mbl'] = data['mbl']
          if (data['hasTDT10']) {
            this.form['bargeVessel'] = data['bargeVessel']
            this.form['bargeVoyage'] = data['bargeVoyage']
          }
        }
      })
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    showShipperDialog() {
      const extendData = {
        contact: this.mblCargoDoc.shipperContact,
        mobile: this.mblCargoDoc.shipperMobile,
        fax: this.mblCargoDoc.shipperFax,
        email: this.mblCargoDoc.shipperEmail,
        zipCode: this.mblCargoDoc.shipperZipCode,
        city: this.mblCargoDoc.shipperCity
      }
      this.showTransAdvanceTextDialog(this.$t('SeaExport.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.isCarrierUserMSC, extendData, true, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showConsigneeDialog() {
      const extendData = {
        contact: this.mblCargoDoc.consigneeContact,
        mobile: this.mblCargoDoc.consigneeMobile,
        fax: this.mblCargoDoc.consigneeFax,
        email: this.mblCargoDoc.consigneeEmail,
        zipCode: this.mblCargoDoc.consigneeZipCode,
        city: this.mblCargoDoc.consigneeCity
      }
      this.showTransAdvanceTextDialog(this.$t('SeaExport.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.isCarrierUserMSC, extendData, true, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    showNotifyDialog() {
      const extendData = {
        contact: this.mblCargoDoc.notifyContact,
        mobile: this.mblCargoDoc.notifyMobile,
        fax: this.mblCargoDoc.notifyFax,
        email: this.mblCargoDoc.notifyEmail,
        zipCode: this.mblCargoDoc.notifyZipCode,
        city: this.mblCargoDoc.notifyCity
      }
      this.showTransAdvanceTextDialog(this.$t('SeaExport.NotifyParty'), this.mergeNotifyLine(), this.splitNotifyLine, this.isCarrierUserMSC, extendData, true, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.mblCargoDoc['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.mblCargoDoc['shipperLine7'] || '')
      return result.trimEnd()
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.mblCargoDoc['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.mblCargoDoc['consigneeLine7'] || '')
      return result.trimEnd()
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.mblCargoDoc['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.mblCargoDoc['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.mblCargoDoc['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.mblCargoDoc['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.mblCargoDoc['shipperLine' + i] = ''
      }
      if (extendData) {
        this.mblCargoDoc.shipperContact = extendData.contact
        this.mblCargoDoc.shipperMobile = extendData.mobile
        this.mblCargoDoc.shipperFax = extendData.fax
        this.mblCargoDoc.shipperEmail = extendData.email
        this.mblCargoDoc.shipperZipCode = extendData.zipCode
        this.mblCargoDoc.shipperCity = extendData.city
      }
    },
    splitConsigneeLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.mblCargoDoc['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.mblCargoDoc['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.mblCargoDoc['consigneeLine' + i] = ''
      }
      if (extendData) {
        this.mblCargoDoc.consigneeContact = extendData.contact
        this.mblCargoDoc.consigneeMobile = extendData.mobile
        this.mblCargoDoc.consigneeFax = extendData.fax
        this.mblCargoDoc.consigneeEmail = extendData.email
        this.mblCargoDoc.consigneeZipCode = extendData.zipCode
        this.mblCargoDoc.consigneeCity = extendData.city
      }
    },
    splitNotifyLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.mblCargoDoc['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.mblCargoDoc['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.mblCargoDoc['notifyLine' + i] = ''
      }
      if (extendData) {
        this.mblCargoDoc.notifyContact = extendData.contact
        this.mblCargoDoc.notifyMobile = extendData.mobile
        this.mblCargoDoc.notifyFax = extendData.fax
        this.mblCargoDoc.notifyEmail = extendData.email
        this.mblCargoDoc.notifyZipCode = extendData.zipCode
        this.mblCargoDoc.notifyCity = extendData.city
      }
    },
    closeMoreShippingScheduleDialog() {
      this.showMoreShippingSchedule = false
      getShippingScheduleDistrict({ jobUuid: this.form.jobUuid,
        tenantId: this.$store.getters.tenantId }).then(res => {
        this.hasChooseShippingSchedule = !!res.data
        this.chooseShippingSchedule = res.data || ''
      })
    },
    showMoreShippingScheduleDialog() {
      this.showMoreShippingSchedule = true
      this.isChooseShippingScheduleBtn = true
    },
    cNptChangeHandler(value, option) {
      this.form.cNptName = ''
      if (option) {
        this.form.cNptNo = option.no
        this.form.cNptName = option.companyName
      }
    },
    cNptBlurHandler(value) {
      this.form.cNptName = ''
      if (value) {
        const cNpt = this.cNptList.find(item => item.no === value)
        if (cNpt) {
          this.form.cNptNo = cNpt.no
          this.form.cNptName = cNpt.companyName
        } else {
          this.form.cNptNo = value
        }
      }
    },
    btnVayageShowHandle() {
      this.voyageShowDialog = true
      // etd
      this.voyageShowDialogData.etd = this.form.etd
      // 船名
      this.voyageShowDialogData.vesselId = this.form.vessel
      // 航次
      this.voyageShowDialogData.voyageNo = this.form.voyageFlight
      // 装货港
      this.voyageShowDialogData.loadingPortCode = this.form.loadingPortCode
      this.voyageShowDialogData.transfering = this.form.transfering
      // 勾选了中转 就将中转港设置为卸货港
      if (this.form.transfering) {
        // 中转港
        this.voyageShowDialogData.dischargingPortCode = this.form.transferPortCode
      } else {
        // 卸货港
        this.voyageShowDialogData.dischargingPortCode = this.form.dischargingPortCode
      }
      // 航线代码
      this.voyageShowDialogData.routeCode = this.form.routeCode
      this.$refs.voyageShowDialog.onshow(this.voyageShowDialogData)
    },
    async callBackLegHandler(param) {
      const data = this.leg.rowData.find(p => p.uuid === this.voyageShowDialogData.legUuid)
      if (data) {
        // 船名
        if (param.englishName) {
          // 船名 根据船名找到对应的数据
          const vesselJson = getObjectByCache(TYPE_NAMES.basic_data_Vessel, 'englishName', param.englishName)
          data.vessel = vesselJson.englishName
          data.ediCode = await this.pm.getCarrierCodeData(data.vessel)
        }
        // 航次
        if (param.voyageNo) {
          data.voyage = param.voyageNo
        }
        // etd
        if (param.etd) {
          data.etd = param.etd
        }
        // eta
        if (param.eta) {
          data.eta = param.eta
        }
        this.leg.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    callbackShippingScheduleHanle(param) {
      console.log('callbackShippingScheduleHanle====>param', param)
      // 弹窗关闭
      this.voyageShowDialog = false
      if (this.voyageShowDialogData.legUuid) {
        // 航程多程管理单独处理逻辑
        this.callBackLegHandler(param)
        return
      }
      // 船名
      if (param.englishName) {
        // 船名 根据船名找到对应的数据
        const vesselJson = getObjectByCache(TYPE_NAMES.basic_data_Vessel, 'englishName', param.englishName)
        vesselJson.value = param.englishName
        this.form.vessel = param.englishName
        this.pm.onVesselSelectionChange(vesselJson)
      }
      // 航次
      if (param.voyageNo) {
        param.value = param.voyageNo
        this.form.voyageFlight = param.voyageNo
        this.pm.onVoyageFlightChange(param)
      }
      // edi代码
      if (param.carrierCode) {
        this.form.carrierCode = param.carrierCode
      }
      // 航线代码
      if (param.routeCode) {
        this.form.routeCode = param.routeCode
        this.checkRouteCode = true
      } else {
        this.checkRouteCode = false
      }
      // etd
      if (param.etd) {
        const oldValue = this.form.etd
        this.form.etd = param.etd
        this.form.sailingDay = JobUtils.dateChange(this.form.etd)
        this.fclPm.ETDChange(oldValue)
        ChargeUtils.updateETDFee(this.form, this.form.etd, this.context, true)
        if (this.form.etd) {
          JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.fclPm.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
        }
      }
    },
    // EDI发送成功
    uploadSuccessHandler() {
      if (this.form) {
        this.form.sendRPASuccess = true
      }
    },
    // 数据服务订阅号更改事件
    async mblBlur(event) {
      // 处理直接绑定的情况（事件对象）
      let mbl, isSoNo
      if (typeof event === 'object' && event.target) {
        mbl = event.target.value
        isSoNo = false // MBL输入框的blur事件
      } else {
        // 处理传统调用方式（直接传值）
        mbl = event
        isSoNo = arguments[1]
      }

      if (!mbl) {
        return
      }
      let mbls = []
      if (isSoNo) {
        mbls = mbl.split('\n')
      } else {
        mbls.push(mbl)
      }
      if (this.openPortDataService === 0) {
        const params = {
          tenantId: this.$store.getters.tenantId
        }
        await getOpening(params).then(async(res) => {
          if (res.data) {
            // 1 则为开通
            this.openPortDataService = 1
          } else {
            // -1则为未开通
            this.openPortDataService = -1
          }
        })
      }
      for (const item of mbls) {
        if (this.openPortDataService === 1 && !/^[a-zA-Z0-9]+$/.test(item)) {
          this.$message.warning(this.$t('SeaExport.SpecialCharacters'))
          return
        }
      }
      // 调用后端接口检查MB/L No.是否重复
      // 只有当订单不是退关状态时才进行校验
      if (!isSoNo && mbl && mbl.trim() && !this.form.shutOut) {
        try {
          const count = await this.pm.isExistMBLSeaExport(mbl)
          if (count > 0) {
            this.$message.warning('MBL号码重复')
          }
        } catch (error) {
          console.error('MBL校验失败:', error)
        }
      }
    },
    onRouteDialogConfirm() {
      if (this.selectedRoute === this.$t('SeaExport.DoNotBackFill')) {
        this.showRouteDialog = false
        return
      }
      this.form.airLine = this.selectedRoute
      this.showRouteDialog = false
    },
    secondVesselETDChange(value) {
      this.form.secondVesselETD = value
      if (this.form.usCustomsClearanceList && this.form.secondVesselETD) {
        syncAtdInfo(this.form.usCustomsClearanceList, this.form.secondVesselETD)
      }
      if (this.form.usCustomsClearanceList && !this.form.secondVesselETD && this.form.atd) {
        syncAtdInfo(this.form.usCustomsClearanceList, this.form.atd)
      }
      if (value) {
        this.form.secondVesselETDChangeDate = value
      }
      // secondVesselETD没值时默认atdChangeDate为atd
      if (!value) {
        this.form.atdChangedDate = this.form.atd
      }
      if (!this.form.secondVesselETD && this.form.atd) {
        this.form.atdChanged = true
      }
    }
  }
}
</script>

<style lang="scss">
  .tab-vessel-eq {
    /deep/ .el-submenu__title{
      border-bottom: none !important;
    }
    .warn-label .el-form-item__label{
      color: orange !important;
    }
    .mbl-red{
      .el-input__inner {
        color: red !important;
      }
    }
    .change_red::v-deep{
      .el-input__inner {
        color: red !important;
      }
    }
    .red-border {
      .el-input__inner,
      .el-textarea__inner {
        border: 1px solid red !important;
      }
    }
  }
</style>
